{
  "common": {
    "cancel": "Annuler"
  },
  "seo": {
    "title": "Coval Flow — Plateforme de gestion d'événements",
    "description": "Planifiez vos événements, coordonnez vos bénévoles et gérez vos contrats depuis un seul espace de travail."
  },
  "notFound": {
    "title": "Page introuvable",
    "text": "La page que vous recherchez n'existe pas ou a été déplacée.",
    "back": "Retour à l'accueil"
  },
  "language": {
    "switcher_aria": "Changer de langue",
    "current": "fr"
  },
  "nav": {
    "home": "Accueil",
    "events": "Événements",
    "volunteers": "Bénévoles",
    "contracts": "Contrats",
    "settings": "Paramètres",
    "section_main": "Pilotage",
    "finances": "Finances",
    "section_settings": "Réglages",
    "profile": "Profil",
    "section_account": "Compte",
    "organisation": "Organisation"
  },
  "auth": {
    "eyebrow": "Accès privé",
    "connected_as": "Connecté en tant que",
    "email_label": "Email",
    "password_label": "Mot de passe",
    "confirm_password_label": "Confirmer le mot de passe",
    "new_password_label": "Nouveau mot de passe",
    "confirm_new_password_label": "Confirmer le nouveau mot de passe",
    "login_title": "Connexion",
    "login_subtitle": "Accédez à votre espace, votre profil et les réglages de votre organisation.",
    "login_submit": "Se connecter",
    "login_link_prefix": "Vous avez déjà un compte ?",
    "login_link_action": "Connectez-vous",
    "register_title": "Créer un compte",
    "register_subtitle": "Créez votre compte et arrivez directement sur votre dashboard.",
    "register_submit": "Créer le compte",
    "register_link_prefix": "Besoin d'un compte ?",
    "register_link_action": "Inscrivez-vous",
    "forgot_password_title": "Mot de passe oublié",
    "forgot_password_subtitle": "Saisissez votre email pour recevoir un lien de réinitialisation.",
    "forgot_password_link": "Mot de passe oublié ?",
    "send_reset_link": "Envoyer le lien",
    "reset_email_sent": "Si le compte existe, un lien de réinitialisation est en cours d'envoi.",
    "reset_password_title": "Réinitialiser le mot de passe",
    "reset_password_subtitle": "Choisissez un nouveau mot de passe pour votre compte.",
    "reset_password_submit": "Réinitialiser",
    "reset_token_missing": "Le lien de réinitialisation est incomplet ou expiré.",
    "back_to_login": "Retour à la connexion",
    "logout": "Se déconnecter",
    "profile_title": "Profil",
    "invalid_credentials": "Email ou mot de passe invalide",
    "password_too_short": "Le mot de passe doit contenir au moins 8 caractères",
    "password_min_hint": "Minimum {{min}} caractères",
    "password_min_chars": "caractères minimum",
    "password_mismatch": "Les mots de passe ne correspondent pas",
    "password_reset_success": "Mot de passe mis à jour avec succès",
    "full_name_label": "Nom complet",
    "full_name_placeholder": "Saisissez votre nom complet"
  },
  "dashboard": {
    "eyebrow": "Centre de contrôle",
    "welcome": "Bon retour, {{name}}",
    "subtitle": "Votre compte est prêt. Ce dashboard deviendra le centre opérationnel pour les événements, les bénévoles et le planning.",
    "organisation_title": "Organisation active",
    "organisation_summary": "{{name}} est connectée et identifiée comme @{{slug}}.",
    "organisation_missing": "Aucune organisation n'est encore rattachée à votre compte.",
    "account_label": "Compte",
    "role_label": "Rôle",
    "status_label": "Statut",
    "status_ready": "Prêt",
    "no_role": "Non défini"
  },
  "profile": {
    "title": "Votre profil",
    "subtitle": "Mettez à jour vos informations et votre mot de passe depuis un seul panneau de contrôle.",
    "organisation_summary": "Connecté à {{name}} avec le rôle {{role}}.",
    "organisation_missing": "Aucune information d'organisation n'est disponible pour le moment.",
    "email_label": "Email",
    "full_name_label": "Nom complet",
    "full_name_placeholder": "Saisissez votre nom complet",
    "current_password_label": "Mot de passe actuel",
    "new_password_label": "Nouveau mot de passe",
    "confirm_new_password_label": "Confirmer le nouveau mot de passe",
    "save": "Enregistrer",
    "eyebrow": "Compte"
  },
  "onboarding": {
    "choice_title": "Bienvenue sur Coval Flow",
    "choice_subtitle": "Créez votre organisation ou rejoignez-en une existante via un lien d'invitation.",
    "choice_create_title": "Créer mon organisation",
    "choice_create_desc": "Configurez votre espace de travail et gérez vos événements depuis votre propre organisation.",
    "choice_join_title": "Rejoindre une organisation",
    "choice_join_desc": "Vous avez reçu un lien d'invitation ? Collez-le ici pour rejoindre l'équipe.",
    "create_title": "Créer votre organisation",
    "create_subtitle": "Renseignez les informations de votre entreprise belge pour configurer votre espace.",
    "join_title": "Rejoindre une organisation",
    "join_subtitle": "Collez le lien d'invitation reçu par email pour rejoindre l'équipe.",
    "step_basic": "Général",
    "step_legal": "Légal",
    "step_address": "Adresse",
    "name_label": "Nom de l'organisation",
    "name_placeholder": "ex. City Lights Festival",
    "slug_label": "Slug public",
    "slug_placeholder": "city-lights-festival",
    "slug_hint": "Utilisez un slug court et unique. Seules les lettres minuscules, chiffres et tirets sont conservés.",
    "org_email_label": "Email de contact",
    "phone_label": "Téléphone",
    "phone_placeholder": "+32 2 000 00 00",
    "website_label": "Site web (optionnel)",
    "website_placeholder": "https://monorganisation.be",
    "legal_notice": "Ces informations permettent d'identifier votre organisation auprès des autorités belges.",
    "company_number_label": "Numéro d'entreprise (BCE)",
    "company_number_invalid": "Format attendu : 0XXX.XXX.XXX",
    "vat_number_label": "Numéro de TVA",
    "vat_number_invalid": "Format attendu : BE0XXX.XXX.XXX",
    "vat_hint": "Le numéro de TVA est automatiquement calculé depuis le numéro BCE.",
    "address_street_label": "Rue",
    "address_street_placeholder": "Rue de la Loi",
    "address_number_label": "N°",
    "address_zip_label": "Code postal",
    "address_city_label": "Ville",
    "address_city_placeholder": "Bruxelles",
    "address_country_label": "Pays",
    "join_instructions": "Copiez-collez le lien d'invitation complet reçu dans votre email. Le token sera extrait automatiquement.",
    "join_link_label": "Lien d'invitation",
    "join_link_placeholder": "https://app.example.com/invitation?token=...",
    "join_token_not_found": "Aucun token d'invitation détecté dans le lien.",
    "join_error": "Invitation invalide, expirée ou déjà utilisée.",
    "join_submit": "Rejoindre l'organisation",
    "back": "Retour",
    "next": "Suivant",
    "submit": "Créer l'organisation",
    "name_required": "Le nom de l'organisation est requis",
    "name_too_short": "Le nom doit contenir au moins 2 caractères",
    "slug_required": "Le slug est requis",
    "slug_invalid": "Lettres minuscules, chiffres et tirets uniquement (ex. mon-org)",
    "email_required": "L'email de contact est requis",
    "email_invalid": "Format d'email invalide",
    "phone_required": "Le numéro de téléphone est requis",
    "website_invalid": "L'URL doit commencer par http:// ou https://",
    "address_street_required": "La rue est requise",
    "address_number_required": "Le numéro est requis",
    "address_zip_required": "Le code postal est requis",
    "address_zip_invalid": "Format attendu : 4 chiffres (ex. 1000)",
    "address_city_required": "La ville est requise",
    "address_country_required": "Le pays est requis"
  },
  "invitation": {
    "eyebrow": "Invitation",
    "title": "Rejoindre cette organisation",
    "subtitle": "Connectez-vous ou créez votre compte pour accepter l'invitation et rejoindre l'équipe.",
    "create_account": "Créer un compte",
    "login": "Se connecter",
    "accepting": "Acceptation de l'invitation",
    "accept_error": "Cette invitation est invalide, expirée ou déjà utilisée.",
    "footer": "La redirection se fera automatiquement une fois l'invitation acceptée."
  },
  "settings": {
    "eyebrow": "Réglages",
    "org_title": "Réglages de l'organisation",
    "org_subtitle": "Gérez le nom de votre organisation et les membres de votre équipe.",
    "nav": {
      "general": "Général",
      "members": "Membres",
      "invitations": "Invitations",
      "volunteer_link": "Lien bénévole",
      "referentials": "Référentiels",
      "finance": "Finance",
      "contract_templates": "Modèles de contrats",
      "plan": "Offre"
    },
    "plan": {
      "current_plan": "Offre actuelle",
      "subtitle": "Ce que votre organisation peut faire aujourd'hui, et où elle en est.",
      "usage_title": "Votre consommation",
      "usage": {
        "active_events": "Événements sur votre offre",
        "team_members": "Membres d'équipe",
        "contract_signatures": "Signatures de contrat"
      },
      "of": "{{current}} sur {{limit}}",
      "unlimited": "Illimité",
      "unlimited_count": "{{current}} — illimité",
      "volunteers_per_event": "Bénévoles par événement",
      "volunteers_hint": "Limite appliquée à chaque événement pris séparément. Un événement peut aller plus loin avec sa propre formule, sans changer votre offre.",
      "loading": "Chargement de votre offre…",
      "error": "Impossible de charger votre offre pour le moment.",
      "covered_title": "Événements couverts",
      "covered_hint": "Les forfaits que vous avez achetés, événement par événement.",
      "covered_tier": "{{tier}} — jusqu'à {{volunteers}} bénévoles",
      "covered_until": "Accès complet jusqu'au {{date}}",
      "covered_ended": "Accès complet terminé le {{date}}",
      "usage_active_events_hint": "Les événements couverts par leur propre forfait ne comptent pas ici."
    },
    "info_title": "Informations",
    "details_title": "Coordonnées de l'organisation",
    "details_copy": "Modifiez le nom et l'email de contact de votre organisation. Cette adresse reçoit également les emails de confirmation des contrats signés via Documenso.",
    "signature_title": "Signature de l'organisation",
    "signature_copy": "Dessinez ici la signature qui pourra être réutilisée dans vos modèles de contrat via la variable {{organisation_signature}}.",
    "signature_save": "Enregistrer la signature",
    "signature_remove": "Supprimer la signature enregistrée",
    "signature_clear_draft": "Effacer le brouillon",
    "signature_preview_label": "Aperçu de la signature",
    "signature_empty": "Aucune signature enregistrée pour le moment.",
    "signature_hint": "Placez {{organisation_signature}} dans le modèle de contrat à l'endroit exact où cette image doit apparaître.",
    "signature_edit": "Modifier la signature",
    "signature_saved": "Signature enregistrée",
    "signature_removed": "Signature supprimée",
    "volunteer_contract_title": "Plafonds de défraiement bénévole",
    "volunteer_contract_copy": "Configurez les montants maximaux autorisés pour les défraiements bénévoles. Ces valeurs sont injectées dans les modèles de contrats via les variables {{organisation_volunteer_reimbursement_max}} et {{organisation_km_rate}}.",
    "owner_function_label": "Fonction du représentant (ex. Président, Directeur artistique)",
    "volunteer_reimbursement_max_label": "Plafond forfaitaire journalier (€)",
    "volunteer_reimbursement_max_annual_label": "Plafond forfaitaire annuel (€)",
    "volunteer_km_rate_label": "Tarif kilométrique (€/km)",
    "volunteer_contract_save": "Enregistrer les plafonds",
    "volunteer_contract_saved": "Plafonds enregistrés",
    "ticketing": {
      "title": "Billetterie",
      "copy": "Connectez une ou plusieurs plateformes de billetterie pour suivre les ventes et les commandes depuis vos événements. Chaque clé API est chiffrée et n'est jamais réaffichée.",
      "list_empty": "Aucune plateforme de billetterie configurée",
      "add_title": "Ajouter une plateforme",
      "provider_label": "Plateforme de billetterie",
      "account_id_label": "Identifiant organisateur (Organizer ID)",
      "api_key_label": "Clé API",
      "api_key_placeholder": "Collez votre clé API",
      "coming_soon": "Bientôt",
      "save": "Enregistrer",
      "test": "Tester",
      "remove": "Supprimer",
      "saved": "Plateforme de billetterie enregistrée",
      "removed": "Plateforme de billetterie supprimée",
      "test_ok": "Connexion réussie — {{count}} événement(s) accessibles",
      "test_failed": "Connexion impossible : vérifiez votre clé API"
    },
    "volunteer_signup_title": "Lien d'inscription bénévole",
    "volunteer_signup_copy": "Partagez ce lien public avec les bénévoles pour qu'ils puissent créer leur compte dans votre organisation.",
    "volunteer_signup_status": "Statut",
    "volunteer_signup_active": "Actif",
    "volunteer_signup_inactive": "Inactif",
    "volunteer_signup_toggle": "Accepter de nouvelles inscriptions",
    "volunteer_signup_link_label": "Lien public d'inscription",
    "volunteer_signup_copy_button": "Copier le lien",
    "volunteer_signup_regenerate": "Régénérer le lien",
    "invitations": {
      "title": "Liens d'invitation équipe",
      "copy": "Créez une invitation pour un membre de l'équipe, puis copiez et partagez le lien généré.",
      "email_label": "Email de la personne invitée",
      "email_placeholder": "nom@entreprise.com",
      "role_label": "Rôle",
      "role_member": "Membre",
      "role_admin": "Admin",
      "submit": "Créer l'invitation",
      "created": "Invitation créée",
      "pending_title": "Invitations en attente",
      "empty": "Aucune invitation en attente.",
      "expires_on": "Expire le {{date}}",
      "copy_button": "Copier le lien d'invitation",
      "event_access_label": "Accès aux événements",
      "event_access_all": "Tous les événements",
      "event_access_specific": "Événements spécifiques",
      "event_access_select_events": "Sélectionnez les événements accessibles",
      "event_access_empty": "Aucun événement disponible.",
      "delete_aria": "Supprimer l'invitation de {{email}}",
      "delete_confirm_title": "Supprimer l'invitation",
      "delete_confirm_copy": "Le lien d'invitation de {{email}} cessera immédiatement de fonctionner. Cette action est irréversible.",
      "delete_confirm_button": "Supprimer l'invitation",
      "deleted": "Invitation supprimée"
    },
    "members_title": "Membres",
    "name_label": "Nom",
    "email_label": "Email de l'organisation",
    "slug_label": "Slug",
    "created_label": "Créée le",
    "role_label": "Votre rôle",
    "save": "Enregistrer",
    "loading": "Chargement…",
    "no_members": "Aucun membre trouvé.",
    "member_email": "Email",
    "member_name": "Nom",
    "member_joined": "Depuis",
    "member_role": "Rôle",
    "members": {
      "role_owner": "Propriétaire",
      "role_admin": "Admin",
      "role_member": "Membre",
      "role_updated": "Rôle du membre mis à jour",
      "event_access_column": "Accès aux événements",
      "access_all": "Tous les événements",
      "access_count": "{{count}} événement(s)",
      "event_access_can_manage": "Peut gérer cet événement",
      "actions": "Actions",
      "edit": "Modifier le membre",
      "edit_title": "Modifier le membre",
      "updated": "Membre mis à jour"
    },
    "referentials": {
      "eyebrow": "Référentiels",
      "title": "Données de référence",
      "subtitle": "Gérez les types de postes utilisés dans votre organisation.",
      "role_types_title": "Types de postes",
      "role_types_copy": "Définissez les types de postes assignables lors des événements.",
      "role_types_empty": "Aucun type de poste.",
      "role_type_placeholder": "Nom du nouveau poste…",
      "role_type_added": "Type de poste ajouté",
      "role_type_backup_label": "Poste de renfort — rempli seulement une fois tous les postes normaux couverts",
      "role_type_backup_badge": "Renfort",
      "role_type_deleted": "Type de poste supprimé",
      "role_type_archived": "Type de poste archivé (utilisé dans des événements existants)",
      "role_type_updated": "Type de poste modifié",
      "add": "Ajouter",
      "delete": "Supprimer",
      "edit": "Modifier",
      "save": "Enregistrer",
      "cancel": "Annuler"
    },
    "finance": {
      "eyebrow": "Finance",
      "title": "Référentiels finance",
      "subtitle": "Gérez les taux de TVA, catégories de dépenses et statuts utilisés par le module de comptabilité.",
      "vat_title": "Taux de TVA",
      "vat_copy": "Taux de TVA éditables appliqués aux transactions.",
      "vat_empty": "Aucun taux de TVA pour le moment.",
      "vat_label_placeholder": "Libellé (ex. 21%)",
      "vat_rate_placeholder": "Taux",
      "vat_country_placeholder": "Pays (optionnel)",
      "categories_title": "Catégories",
      "categories_copy": "Catégories pour classer les dépenses et les recettes.",
      "categories_empty": "Aucune catégorie pour le moment.",
      "category_placeholder": "Nom de la catégorie…",
      "category_type_expense": "Dépense",
      "category_type_income": "Recette",
      "add": "Ajouter",
      "delete": "Supprimer",
      "added": "Entrée ajoutée",
      "deleted": "Entrée supprimée",
      "updated": "Catégorie modifiée",
      "edit": "Modifier",
      "save": "Enregistrer",
      "cancel": "Annuler"
    }
  },
  "camera": {
    "title": "Prendre une photo",
    "starting": "Démarrage de la caméra…",
    "capture": "Capturer",
    "retake": "Reprendre",
    "use_photo": "Utiliser cette photo",
    "cancel": "Annuler",
    "preview_alt": "Aperçu de la photo prise",
    "error": "La caméra est indisponible. Vérifiez les autorisations et réessayez."
  },
  "volunteerApp": {
    "eyebrow": "Espace bénévole",
    "loading": "Chargement du lien d'inscription...",
    "title": "Créer votre compte bénévole",
    "login_title": "Connexion bénévole",
    "login_copy": "Retrouvez vos shifts, vos documents et les dernières informations de votre organisation.",
    "login_submit": "Se connecter",
    "login_error": "Impossible de vous connecter avec ces identifiants.",
    "forgot_password_link": "Mot de passe oublié ?",
    "forgot_password_title": "Mot de passe oublié",
    "forgot_password_subtitle": "Saisissez votre email pour recevoir un lien de réinitialisation.",
    "send_reset_link": "Envoyer le lien",
    "reset_email_sent": "Si le compte existe, un lien de réinitialisation est en cours d'envoi.",
    "back_to_login": "Retour à la connexion",
    "reset_password_title": "Réinitialiser le mot de passe",
    "reset_password_subtitle": "Choisissez un nouveau mot de passe pour votre compte bénévole.",
    "reset_password_submit": "Réinitialiser",
    "reset_token_missing": "Le lien de réinitialisation est incomplet ou expiré.",
    "new_password_label": "Nouveau mot de passe",
    "confirm_new_password_label": "Confirmer le nouveau mot de passe",
    "password_mismatch": "Les mots de passe ne correspondent pas",
    "password_reset_success": "Mot de passe mis à jour avec succès",
    "first_name": "Prénom",
    "last_name": "Nom",
    "email": "Email",
    "phone": "Téléphone",
    "password": "Mot de passe",
    "confirm_password": "Confirmer le mot de passe",
    "password_hint": "Le mot de passe doit contenir au moins 8 caractères",
    "confirm_password_hint": "Les mots de passe doivent correspondre",
    "step_account": "Compte",
    "step_legal": "Infos légales",
    "step_address": "Adresse",
    "account_section_title": "Informations de connexion",
    "account_section_copy": "Commencez par vos infos de base pour créer votre accès.",
    "continue": "Continuer",
    "back": "Retour",
    "intro_account_title": "Compte personnel",
    "intro_account_copy": "Email, mot de passe et coordonnées de contact.",
    "intro_admin_title": "Données utiles",
    "intro_admin_copy": "Adresse, numéro national et compte bancaire si nécessaire.",
    "intro_access_title": "Accès direct",
    "intro_access_copy": "Connexion ensuite à l'espace bénévole pour suivre vos shifts.",
    "legal_section_title": "Informations légales et bancaires",
    "legal_section_copy": "Ces informations sont nécessaires pour vous couvrir pendant vos missions.",
    "legal_notice_title": "Pourquoi ces informations ?",
    "legal_notice_body": "Votre numéro national et votre IBAN nous permettent d'établir votre contrat de bénévolat. Ce document est exigé par notre assurance pour vous couvrir pendant vos missions et, le cas échéant, pour vous rembourser vos frais ou indemnités forfaitaires conformément à la législation belge.",
    "gdpr_retention_title": "Protection de vos données (RGPD)",
    "gdpr_retention_body": "Vos données sont traitées uniquement par votre organisation, dans le cadre de la gestion de votre engagement bénévole et de ses obligations légales (assurance, comptabilité). Elles sont conservées le temps strictement nécessaire à ces finalités, puis supprimées ou archivées conformément aux délais légaux. Vous pouvez à tout moment exercer vos droits d'accès, de rectification, de limitation, de portabilité ou de suppression en contactant directement votre organisation.",
    "address_section_title": "Adresse postale",
    "address_section_copy": "Cette adresse est utilisée pour vos documents officiels et la déclaration à l'assurance.",
    "national_number": "Numéro national",
    "address_street": "Rue",
    "address_number": "Numéro",
    "address_zip": "Code postal",
    "address_city": "Ville",
    "address_country": "Pays",
    "bank_account": "Compte bancaire / IBAN",
    "first_name_placeholder": "Marie",
    "last_name_placeholder": "Dupont",
    "email_placeholder": "marie.dupont@example.com",
    "phone_placeholder": "+32 470 12 34 56",
    "phone_invalid": "Saisissez un numéro de téléphone valide (pas une adresse email).",
    "password_placeholder": "Au moins 8 caractères",
    "confirm_password_placeholder": "Répétez votre mot de passe",
    "national_number_placeholder": "00.00.00-000.00",
    "bank_account_placeholder": "BE00 0000 0000 0000",
    "address_street_placeholder": "Rue de la Loi",
    "address_number_placeholder": "16",
    "address_zip_placeholder": "1000",
    "address_city_placeholder": "Bruxelles",
    "address_country_placeholder": "BE",
    "submit": "Créer mon compte",
    "already_account": "Déjà inscrit ?",
    "go_to_login": "Aller à la connexion",
    "success_title": "Compte créé",
    "success_copy": "Votre compte bénévole est prêt. Vous pouvez maintenant vous connecter.",
    "unavailable_title": "Inscription indisponible",
    "unavailable_copy": "Ce lien d'inscription est invalide, expiré ou désactivé.",
    "dashboard_eyebrow": "Portail bénévole",
    "dashboard_title": "Bonjour {{name}}",
    "dashboard_copy": "Cet écran regroupe vos prochains shifts, vos horaires confirmés et vos documents utiles.",
    "upcoming_copy": "Gardez un oeil sur vos prochains postes et confirmez votre présence dès que possible.",
    "past_copy": "Retrouvez ici vos affectations déjà passées.",
    "documents_copy": "Tous les documents utiles transmis par l'organisation sont centralisés ici.",
    "profile_title": "Mon profil",
    "profile_copy": "Vue rapide sur vos informations et votre activité.",
    "stat_upcoming": "Shifts à venir",
    "stat_documents": "Documents",
    "stat_past": "Shifts passés",
    "photo_import": "Importer une photo",
    "photo_take": "Prendre une photo",
    "photo_remove": "Supprimer la photo",
    "photo_invalid_type": "Veuillez choisir une image PNG, JPEG ou WebP.",
    "photo_too_large": "L'image est trop volumineuse (5 Mo maximum).",
    "upcoming_title": "Mes shifts",
    "past_title": "Shifts passés",
    "documents_title": "Mes documents",
    "documents_col_name": "Document",
    "documents_col_status": "Statut",
    "documents_col_download": "Téléchargement",
    "documents_col_sign": "Signature",
    "no_upcoming": "Aucun prochain shift assigné pour le moment.",
    "no_past": "Aucun shift passé à afficher.",
    "no_documents": "Aucun document n'est encore disponible.",
    "document_default_type": "Document",
    "documents_download": "Télécharger le PDF",
    "documents_sign": "Signer",
    "documents_signed": "Déjà signé",
    "documents_sign_unavailable": "Aucun lien de signature n'est encore disponible pour ce document.",
    "documents_download_unavailable": "Le PDF signé sera disponible une fois ce contrat signé.",
    "status_pending": "En attente",
    "status_confirmed": "Confirmé",
    "status_cancelled": "Indisponible",
    "confirm_button": "Confirmer ma présence",
    "confirmed_button": "Présence confirmée",
    "cancel_button": "Je ne peux pas venir",
    "cancel_modal_title": "Signaler une indisponibilité",
    "cancel_modal_copy": "Expliquez la raison si utile. Le shift reste visible pour l'organisateur jusqu'à traitement.",
    "cancel_reason": "Message optionnel",
    "cancel_submit": "Envoyer l'indisponibilité",
    "logout": "Se déconnecter",
    "no_email": "Aucun email renseigné",
    "no_phone": "Aucun téléphone renseigné",
    "nav_events": "Événements",
    "nav_preferences": "Préférences",
    "nav_upcoming": "À venir",
    "nav_documents": "Documents",
    "nav_past": "Passés",
    "events_page_copy": "Découvrez les événements de votre organisation et inscrivez-vous à ceux qui vous intéressent.",
    "events_empty": "Aucun événement actif pour le moment.",
    "event_register": "Je veux participer",
    "event_unregister": "Me désinscrire",
    "event_unregister_confirm_title": "Se désinscrire",
    "event_unregister_confirm_copy": "Êtes-vous sûr de vouloir vous désinscrire de cet événement ?",
    "event_unregister_confirm_button": "Confirmer la désinscription",
    "reg_status_pending": "En attente",
    "reg_status_approved": "Accepté",
    "reg_status_rejected": "Refusé",
    "not_registered": "Non inscrit",
    "registration_col": "Inscription",
    "availability_col": "Disponibilité",
    "availability_locked": "Inscrivez-vous d'abord",
    "availability_missing": "À renseigner",
    "availability_ready": "Renseignée",
    "availability_edit": "Modifier",
    "event_detail_back": "Retour aux événements",
    "partner_title": "Mon binôme",
    "partner_copy": "Choisissez un autre bénévole avec qui vous aimeriez travailler en même temps. Nous essaierons de vous planifier ensemble.",
    "partner_label": "Binôme",
    "partner_placeholder": "Choisir un binôme",
    "partner_clear": "Retirer le binôme",
    "partner_empty": "Aucun autre bénévole n'est encore inscrit à cet événement.",
    "guests_title": "Guest List",
    "guests_copy": "Les personnes invitées à cet événement. Pointez-les présentes à leur arrivée à l'entrée.",
    "guests_empty": "Aucun invité n'a été ajouté à cet événement.",
    "guests_present_count": "{{present}}/{{total}} présents",
    "guests_plus_ones": "+{{n}} invités",
    "guests_present": "Présent",
    "guests_mark_present": "Pointer",
    "guests_view": "Guest List",
    "guests_search_placeholder": "Rechercher un invité",
    "guests_no_match": "Aucun invité ne correspond à votre recherche.",
    "pref_want": "Souhaité",
    "pref_avoid": "À éviter",
    "pref_none": "Pas de préférence",
    "pref_remove": "Retirer la préférence",
    "registrations_title": "Mes inscriptions",
    "registrations_copy": "Suivez vos demandes d'inscription aux événements.",
    "no_registrations": "Aucune inscription en attente.",
    "stat_registrations": "Inscriptions",
    "max_hours_label": "Heures max par événement :",
    "max_hours_none": "aucune limite définie",
    "max_hours_edit": "Modifier",
    "max_hours_modal_title": "Définir les heures max",
    "max_hours_modal_copy": "Indiquez le nombre maximum d'heures que vous souhaitez travailler par événement. Laissez vide pour supprimer la limite.",
    "max_hours_save": "Enregistrer",
    "personal_info_label": "Informations personnelles",
    "personal_info_edit": "Modifier mes infos",
    "personal_info_modal_title": "Modifier vos informations personnelles",
    "personal_info_modal_copy": "Gardez vos coordonnées et données administratives à jour afin que l'organisation puisse vous joindre et préparer vos documents.",
    "personal_info_identity": "Identité & contact",
    "personal_info_admin": "Informations administratives",
    "personal_info_address": "Adresse",
    "personal_info_save": "Enregistrer",
    "delete_account_label": "Zone sensible",
    "delete_account_hint": "Supprimer définitivement votre compte bénévole et vos données personnelles.",
    "delete_account": "Supprimer mon compte",
    "delete_account_modal_title": "Supprimer mon compte",
    "delete_account_warning": "Cette action est définitive et ne peut pas être annulée.",
    "delete_account_copy": "Votre compte sera fermé immédiatement et vous serez déconnecté de tous vos appareils.",
    "delete_account_erased": "Effacé : votre nom, e-mail, téléphone, numéro national, compte bancaire, adresse, photo et préférences.",
    "delete_account_kept": "Conservé : les contrats que vous avez signés et les écritures comptables liées, que l'organisation doit garder pour ses obligations légales. Ils ne seront plus rattachés à votre nom.",
    "delete_account_password_label": "Confirmez avec votre mot de passe",
    "delete_account_password_placeholder": "Votre mot de passe",
    "delete_account_password_invalid": "Mot de passe incorrect",
    "delete_account_confirm": "Supprimer définitivement",
    "delete_account_success": "Votre compte a été supprimé",
    "shift_col_event": "Événement",
    "shift_col_schedule": "Horaire",
    "shift_col_status": "Statut",
    "shift_confirm": "Confirmer",
    "shift_decline": "Refuser",
    "feedback_col": "Avis",
    "feedback_leave": "Laisser un avis",
    "feedback_edit": "Modifier mon avis",
    "feedback_modal_title": "Avis sur l'événement",
    "feedback_modal_copy": "Partagez votre expérience sur « {{event}} ». Votre commentaire aide l'organisation à s'améliorer.",
    "feedback_comment_label": "Votre commentaire",
    "feedback_comment_placeholder": "Qu'est-ce qui s'est bien passé ? Qu'est-ce qui pourrait être amélioré ?",
    "feedback_submit": "Envoyer l'avis",
    "feedback_anonymous_label": "Laisser cet avis de manière anonyme",
    "feedback_anonymous_hint": "Si activé, l'organisation ne verra pas votre nom à côté de ce commentaire.",
    "nickname": "Pseudo",
    "nickname_placeholder": "ex. Alex",
    "nickname_hint": "S'il est défini, votre pseudo remplace votre nom sur l'horaire.",
    "nickname_too_short": "Votre pseudo doit contenir au moins 4 caractères.",
    "hero_nickname": "Pseudo : {{nickname}}"
  },
  "contact": {
    "dropdownPlaceholder": "Sujet*"
  },
  "events": {
    "dashboard_eyebrow": "Tableau opérationnel",
    "dashboard_title": "Événements de {{name}}",
    "dashboard_subtitle": "Pilotez tous les événements depuis une seule surface: recrutement, contrats et planning restent lisibles en un coup d'oeil.",
    "empty": "Aucun événement trouvé pour cette organisation.",
    "actions": {
      "create": "Créer un événement",
      "open": "Ouvrir l'événement",
      "save": "Enregistrer",
      "cancel": "Annuler",
      "edit": "Modifier",
      "activate": "Activer",
      "reactivate": "Réactiver",
      "complete": "Marquer comme terminé",
      "complete_confirm": "Marquer comme terminé",
      "duplicate": "Dupliquer",
      "archive": "Archiver",
      "archive_confirm": "Confirmer l'archivage",
      "activate_success": "Événement activé avec succès",
      "reactivate_success": "Événement réactivé avec succès",
      "complete_success": "Événement marqué comme terminé",
      "save_success": "Événement enregistré avec succès"
    },
    "filters": {
      "eyebrow": "Filtre",
      "title": "Périmètre d'affichage",
      "label": "Statut",
      "placeholder": "Choisir un statut",
      "all": "Tous les événements",
      "draft": "Brouillon",
      "active": "Actif",
      "completed": "Terminé",
      "archived": "Archivé"
    },
    "stats": {
      "total_events": "Événements",
      "active_events": "Actifs",
      "recruited_volunteers": "Bénévoles recrutés",
      "generated_planning": "Plannings générés"
    },
    "labels": {
      "name": "Événement",
      "dates": "Dates",
      "actions": "Actions",
      "roles": "Postes",
      "volunteers": "Bénévoles",
      "contracts": "Contrats",
      "planning": "Planning",
      "planning_yes": "Oui",
      "planning_no": "Non",
      "location_missing": "Lieu non renseigné",
      "description_missing": "Aucune description pour cet événement.",
      "pending_badge": "{{count}} en attente",
      "pending_hint": "Inscriptions de bénévoles à valider"
    },
    "form": {
      "eyebrow": "Nouvel événement",
      "title": "Créer un nouvel événement",
      "subtitle": "Cet événement sera rattaché à {{name}} et deviendra le conteneur principal pour les bénévoles, les postes et le planning.",
      "name": "Nom de l'événement",
      "start_date": "Date de début",
      "end_date": "Date de fin",
      "location": "Lieu",
      "org_label": "Organisation",
      "description": "Description",
      "timeline_label": "Fenêtre",
      "duration_label": "Durée",
      "duration_single": "{{count}} jour",
      "duration_plural": "{{count}} jours",
      "date_error": "La date de fin doit être postérieure à la date de début.",
      "auto_shift_hint": "Si la date de début rattrape la fin, la date de fin est décalée automatiquement pour conserver une plage valide.",
      "preview_eyebrow": "Aperçu en direct",
      "preview_title": "Résumé de l'événement",
      "preview_copy": "Vérifiez le cadrage avant l'enregistrement. Ce panneau se met à jour pendant la saisie.",
      "preview_name_placeholder": "Événement sans titre",
      "preview_ready": "Prêt",
      "preview_pending": "À compléter",
      "side_title": "Avant publication",
      "side_copy": "Commencez par le cadrage principal. Vous pourrez ensuite affiner les bénévoles, la structure des postes et les contrats depuis la fiche événement.",
      "sections": {
        "basics_eyebrow": "Identité",
        "basics_title": "Informations principales",
        "basics_copy": "Commencez par le nom visible et le lieu où l'équipe opérera sur le terrain.",
        "schedule_eyebrow": "Dates",
        "schedule_title": "Fenêtre de l'événement",
        "schedule_copy": "Gardez un début et une fin clairs pour que le planning et l'affectation des bénévoles restent cohérents.",
        "context_eyebrow": "Contexte",
        "context_title": "Notes opérationnelles",
        "context_copy": "Ajoutez assez de contexte maintenant pour garder une fiche lisible quand le dashboard se remplira.",
        "windows_eyebrow": "Horaires",
        "windows_title": "Plages horaires par jour",
        "windows_copy": "Définissez si besoin la fenêtre horaire active pour chaque jour. Ces plages déterminent ce qui s'affiche dans la timeline de couverture et restent modifiables plus tard."
      },
      "hints": {
        "organisation": "L'événement est lié à l'organisation actuellement sélectionnée dans votre espace.",
        "dates": "Choisissez une fenêtre de début et de fin claire pour garder un planning cohérent.",
        "details": "Ajoutez le lieu et le contexte dès maintenant pour rendre le dashboard plus lisible ensuite."
      }
    },
    "detail": {
      "eyebrow": "Détail de l'événement",
      "info_title": "Informations de l'événement",
      "readonly": "Lecture seule"
    },
    "cover": {
      "add": "Ajouter une image de couverture",
      "change": "Changer la couverture",
      "remove": "Supprimer la couverture",
      "empty": "Aucune image de couverture",
      "alt": "Image de couverture de {{name}}",
      "modal_title": "Image de couverture de l'événement",
      "modal_copy": "Importez une image PNG, JPEG ou WebP (max 5 Mo). Elle est affichée avec les informations de l'événement.",
      "file_label": "Image de couverture",
      "save": "Enregistrer la couverture",
      "save_success": "Image de couverture mise à jour",
      "remove_success": "Image de couverture supprimée"
    },
    "tabs": {
      "roles": "Postes",
      "volunteers": "Bénévoles",
      "guestlist": "Guest List",
      "accounting": "Compta",
      "contracts": "Contrats",
      "planning": "Planning",
      "feedback": "Avis",
      "billetterie": "Billetterie"
    },
    "billetterie": {
      "title": "Billetterie",
      "subtitle": "Ventes et commandes en direct, issues de votre plateforme de billetterie.",
      "not_configured_title": "Aucune plateforme de billetterie configurée",
      "not_configured_copy": "Ajoutez la clé API de votre plateforme de billetterie dans les réglages de l'organisation pour activer cet onglet.",
      "go_to_settings": "Ouvrir les réglages",
      "link_title": "Relier un événement de billetterie",
      "link_copy": "Choisissez l'événement de la plateforme correspondant à cet événement pour afficher ses ventes.",
      "provider_label": "Plateforme",
      "provider_unavailable": "La plateforme reliée n'est plus configurée pour cette organisation.",
      "link_select_label": "Événement de la plateforme",
      "link_button": "Relier l'événement",
      "link_empty": "Aucun événement disponible pour cette clé API.",
      "linked_label": "Événement relié",
      "unlink_button": "Délier",
      "refresh": "Rafraîchir",
      "kpi_income": "Recettes",
      "kpi_tickets": "Billets vendus",
      "kpi_orders": "Commandes",
      "tiers_title": "Catégories de billets",
      "tier_name": "Catégorie",
      "tier_price": "Prix",
      "tier_sold": "Vendus",
      "tier_available": "Disponibles",
      "orders_title": "Commandes",
      "order_customer": "Client",
      "order_email": "Email",
      "order_status": "Statut",
      "order_total": "Total",
      "order_date": "Date",
      "orders_empty": "Aucune commande pour le moment.",
      "linked_success": "Événement relié avec succès",
      "unlinked_success": "Événement délié avec succès"
    },
    "accounting": {
      "total_income": "Total recettes",
      "total_expense": "Total dépenses",
      "balance": "Solde",
      "add": "Ajouter une transaction",
      "add_title": "Nouvelle transaction",
      "add_submit": "Ajouter",
      "edit": "Modifier",
      "edit_title": "Modifier la transaction",
      "edit_submit": "Enregistrer",
      "delete": "Supprimer",
      "empty": "Aucune transaction enregistrée pour le moment.",
      "created": "Transaction ajoutée",
      "updated": "Transaction mise à jour",
      "deleted": "Transaction supprimée",
      "validation": "Un libellé, un montant et un taux de TVA sont requis.",
      "result_title": "Résultat & TVA",
      "result_net_ht": "Résultat net (HT)",
      "result_gross": "Bénéfice brut (TTC)",
      "result_net": "Bénéfice net (HT)",
      "vat_collected": "TVA collectée",
      "vat_deductible": "TVA déductible",
      "vat_net": "TVA nette (déductible − collectée)",
      "result_real": "Résultat réel",
      "crews_title": "Crews & répartition",
      "crews_copy": "Crews co-producteurs qui se partagent le résultat de cet événement.",
      "crews_empty": "Aucun crew participant pour le moment.",
      "crews_total_warning": "La somme des parts est de {{total}}% (devrait être 100%).",
      "crews_col_name": "Crew",
      "crews_col_share": "Part",
      "crew_select": "Choisir un crew",
      "crew_name_label": "Nom du crew",
      "crew_name_placeholder": "ex. FalcOhm",
      "crew_share_label": "Clé de répartition (%)",
      "crew_add": "Ajouter",
      "crew_added": "Crew ajouté",
      "crew_removed": "Crew retiré",
      "crew_remove": "Retirer le crew",
      "multi_org_label": "Événement multi-organisations",
      "multi_org_copy": "Activez pour répartir la comptabilité entre plusieurs organisations co-productrices.",
      "multi_org_disable_confirm": "Désactiver supprimera les {{count}} répartition(s) configurée(s) et masquera la colonne Organisation. Continuer ?",
      "multi_org_disable_action": "Désactiver",
      "multi_org_cancel": "Annuler",
      "multi_org_disabled": "Mode multi-organisations désactivé",
      "settlement_title": "Règlement inter-crews",
      "settlement_empty": "Ajoutez des crews participants pour calculer le règlement.",
      "settlement_warning": "Le commun contient des lignes non-cash non couvertes par la caisse — à vérifier manuellement.",
      "settlement_result_note": "Chaque crew garde ses recettes/dépenses propres à 100 % ; seule la perte (ou le bénéfice) commun est partagée par clé.",
      "settlement_col_crew": "Crew",
      "settlement_col_income": "Recettes propres (HT)",
      "settlement_col_expense": "Dépenses propres (HT)",
      "settlement_col_common_share": "Part du commun (HT)",
      "settlement_col_final": "Solde final (HT)",
      "settlement_debug_toggle": "Debug JSON",
      "settlement_col_tva": "TVA nette",
      "settlement_col_cash": "Part caisse",
      "settlement_flows_title": "D'où vient ce montant ?",
      "settlement_flows_empty": "Aucune restitution ni part à répartir.",
      "settlement_flows_owes": "{{from}} doit à {{to}}",
      "settlement_flows_subtotal": "Sous-total",
      "settlement_flows_help": "Chaque crew doit de l'argent aux autres (sa part des dépenses qu'ils ont avancées) et leur en réclame (sa part des recettes qu'ils ont encaissées). On additionne tout ça par crew pour obtenir un solde unique, puis on fait payer les débiteurs aux créanciers. D'où quelques virements au lieu de dizaines.",
      "settlement_final_help": "Ce qu'il reste à virer une fois tout compensé. Chaque montant sort des soldes nets calculés juste en dessous : un crew débiteur vire à un crew créditeur. La TVA s'ajoute par-dessus, car ce virement fait l'objet d'une facture entre crews.",
      "settlement_balance_note": "Pour chaque crew : où elle en est réellement aujourd'hui, comparé à sa juste part une fois le résultat partagé. L'écart, c'est ce qu'on lui doit ou ce qu'elle doit verser.",
      "settlement_story_paid": "Ce qu'elle a payé",
      "settlement_story_collected": "Ce qu'elle a encaissé",
      "settlement_story_cash": "Sa part de la caisse",
      "settlement_story_cash_tag": "espèces",
      "settlement_story_cash_note": "La part de caisse se règle en espèces, la main à la main : elle n'est pas dans le virement ni sur la facture.",
      "settlement_story_position": "→ Où elle en est aujourd'hui",
      "settlement_story_fair": "Sa juste part du résultat",
      "settlement_story_gets_back": "On lui doit",
      "settlement_story_pays_back": "Elle doit verser",
      "settlement_story_why_gets_back": "Elle a supporté plus que sa part : on lui rend la différence.",
      "settlement_story_why_pays_back": "Elle a supporté moins que sa part : elle verse la différence.",
      "settlement_flows_show_detail": "Voir le détail ligne par ligne ({{count}} paires)",
      "settlement_flows_hide_detail": "Masquer le détail ligne par ligne",
      "settlement_split_title": "Ce que chaque crew supporte au final",
      "settlement_reason_own_income": "Recettes propres de {{to}} encaissées par {{from}}",
      "settlement_reason_own_expense": "Dépenses propres de {{from}} payées par {{to}}",
      "settlement_reason_common_income": "Part de {{to}} — recettes communes encaissées par {{from}}",
      "settlement_reason_common_expense": "Part de {{from}} — dépenses communes avancées par {{to}}",
      "settlement_recap_title": "Récapitulatif par crew",
      "recap_paid_ht": "Payé HT",
      "recap_paid_vat": "TVA payée",
      "recap_paid_ttc": "Payé TTC",
      "recap_collected_ht": "Encaissé HT",
      "recap_collected_vat": "TVA encaissée",
      "recap_collected_ttc": "Encaissé TTC",
      "settlement_cash_title": "Détail de la caisse commune",
      "settlement_cash_recettes": "Recettes (espèces)",
      "settlement_cash_depenses": "Dépenses (espèces)",
      "settlement_cash_solde": "Solde caisse commune",
      "settlement_cash_shared_note": "dont part commune partagée au prorata : {{amount}}",
      "settlement_cash_crew_split": "{{shared}} part commune + {{own}} cash propre",
      "settlement_cash_crew_shared_only": "{{shared}} part commune",
      "settlement_no_transfer": "Aucun virement nécessaire (tout se compense).",
      "settlement_final_title": "Le virement à faire",
      "settlement_reimb_note": "Un seul virement net par crew : au taux dominant des recettes encaissées par l'émetteur, ou 21 % s'il couvre une perte (aucune recette encaissée). Le cash est réglé physiquement, hors facture.",
      "vat_exempt": "Exonéré TVA",
      "sim_title": "Simulateur de rentabilité",
      "sim_hint": "Règle universelle : point mort = coûts fixes ÷ prix d'entrée HT. Le bar est optionnel — laisse 0 pour un point mort prudent.",
      "sim_fixed_costs": "Coûts fixes à couvrir (HT)",
      "sim_capacity": "Capacité salle",
      "sim_ticket_price": "Prix d'entrée (TTC)",
      "sim_bar_spend": "Conso bar / pers. (optionnel)",
      "sim_bar_margin": "Marge bar",
      "sim_contribution": "Contribution / entrée",
      "sim_breakeven": "Point mort (entrées)",
      "sim_fill_needed": "Remplissage nécessaire",
      "sim_attendance": "Présents attendus",
      "sim_revenue": "Recettes (HT)",
      "sim_result": "Résultat",
      "sim_suggested_price": "Prix conseillé à ce remplissage",
      "sim_bar_ref": "Marge bar réelle du ledger : {{amount}} — sert à estimer la marge bar / pers.",
      "export_pdf": "Exporter en PDF",
      "config_title": "Réglages compta",
      "config_copy": "Configurez les crews co-producteurs et leur clé de répartition pour cet événement.",
      "config_done": "Terminé",
      "expenses_title": "Dépenses",
      "income_title": "Entrées",
      "grid_hint": "Saisissez dans les cellules — une nouvelle ligne se crée en remplissant celle du bas.",
      "grid_search": "Rechercher…",
      "grid_no_match": "Aucun résultat.",
      "grid_detail_placeholder": "Libellé…",
      "grid_new_row": "nouvelle ligne",
      "grid_add_row": "Ajouter une transaction",
      "grid_total": "Total",
      "col_vat_rate": "TVA %",
      "col_ttc": "TTC",
      "col_ht": "HT",
      "col_vat_amount": "TVA",
      "col_mode": "Paiement",
      "col_org": "Payé pour",
      "col_org_income": "Revient à",
      "col_paid_by": "Payé par",
      "col_received_by": "Reçu par",
      "col_settled_by": "Payé/Reçu par",
      "col_resize": "Redimensionner la colonne",
      "from_contract": "Montant issu d'un contrat signé — à modifier depuis le contrat",
      "mode_cash": "Espèces",
      "mode_card": "Carte",
      "mode_transfer": "Virement",
      "status_paid": "Payé",
      "status_to_pay": "À payer",
      "status_provisional": "Prévisionnel",
      "type": "Type",
      "type_income": "Recette",
      "type_expense": "Dépense",
      "date": "Date",
      "label": "Libellé",
      "amount_incl_vat": "Montant (TTC)",
      "vat_rate": "Taux de TVA",
      "vat_placeholder": "Choisir un taux",
      "category": "Catégorie",
      "category_placeholder": "Catégorie (optionnel)",
      "crew": "Crew",
      "crew_placeholder": "Crew (optionnel)",
      "common": "Commun",
      "payment_mode": "Paiement",
      "payment_cash": "Cash",
      "payment_card": "Carte",
      "payment_transfer": "Virement",
      "status": "Statut",
      "optional": "Optionnel",
      "col_date": "Date",
      "col_label": "Libellé",
      "col_category": "Catégorie",
      "col_crew": "Crew",
      "col_amount": "Montant",
      "col_status": "Statut",
      "col_actions": "Actions"
    },
    "tab_copy": {
      "roles": "Cet événement suit actuellement {{count}} postes. La gestion détaillée des postes arrive dans l'epic suivant, mais le compteur et l'état général sont déjà visibles ici.",
      "volunteers": "{{count}} bénévoles sont rattachés à cet événement. Le flux de gestion complet s'appuiera sur cette base dans l'epic dédié.",
      "contracts": "La signature des contrats arrive avec l'EPIC-10. La progression actuelle de cet événement est de {{signed}}/{{total}} contrats signés.",
      "planning_ready": "Un planning a déjà été généré pour cet événement.",
      "planning_missing": "Aucun planning n'a encore été généré pour cet événement."
    },
    "complete": {
      "title": "Marquer l'événement comme terminé",
      "copy": "Marquer « {{name}} » comme terminé. Les bénévoles pourront alors laisser un avis sur cet événement."
    },
    "feedback": {
      "title": "Avis des bénévoles",
      "subtitle": "Commentaires laissés par les bénévoles après l'événement.",
      "empty": "Aucun avis n'a encore été laissé.",
      "anonymous": "Anonyme",
      "sort_author": "Auteur",
      "sort_date": "Date"
    },
    "archive": {
      "title": "Archiver l'événement",
      "copy": "Archiver {{name}} fera passer l'événement en lecture seule."
    },
    "guests_tab": {
      "add_success": "Invité ajouté à l'événement",
      "remove": "Retirer",
      "mark_present": "Pointer",
      "unmark_present": "Dépointer",
      "present": "Présent",
      "share": "Partager",
      "share_title": "Partager la Guest List",
      "share_copy": "Toute personne disposant de ce lien (lecture seule) peut voir la Guest List (noms, nombre d'invités et présence). Révocable à tout moment.",
      "share_revoke": "Révoquer le lien",
      "share_revoked": "Lien de partage révoqué",
      "copy": "Copier une liste",
      "copy_title": "Copier une Guest List",
      "copy_copy": "Importer les invités d'un autre événement de votre organisation dans celui-ci. Les contacts déjà invités sont ignorés.",
      "copy_no_source": "Aucun autre événement dans votre organisation pour l'instant : il n'y a rien à copier.",
      "copy_source_label": "Événement source",
      "copy_source_placeholder": "Choisir un événement…",
      "copy_submit": "Copier les invités",
      "copy_success": "{{count}} invité(s) copié(s)",
      "export_pdf": "Exporter en PDF",
      "empty": "Aucun invité n'a encore été ajouté à cet événement.",
      "count_label": "Nombre d'invités : {{count}}",
      "list_search_placeholder": "Rechercher un invité",
      "no_match": "Aucun invité ne correspond à votre recherche.",
      "col_first_name": "Prénom",
      "col_last_name": "Nom",
      "col_guest_count": "# Invités",
      "col_invited_by": "Invité par",
      "invited_by_placeholder": "Artiste, contact…",
      "add_row": "Ajouter une ligne"
    },
    "volunteers_tab": {
      "add": "Ajouter un bénévole",
      "add_title": "Ajouter des bénévoles à l'événement",
      "add_submit": "Ajouter la sélection",
      "export_remunerations": "Exporter les rémunérations (CSV)",
      "search_label": "Rechercher des bénévoles",
      "search_placeholder": "Rechercher par nom ou email…",
      "search_empty": "Aucun bénévole ne correspond à cette recherche.",
      "available_count": "{{count}} bénévoles disponibles",
      "selected_count": "{{count}} sélectionnés",
      "email_missing": "Aucun email renseigné",
      "col_name": "Nom",
      "col_email": "Email",
      "col_phone": "Téléphone",
      "col_role": "Poste",
      "col_primary_role": "Rôle principal",
      "col_remuneration": "Rémunération",
      "col_contract": "Contrat",
      "col_actions": "Actions",
      "add_success": "Bénévoles ajoutés à l'événement",
      "empty": "Aucun bénévole n'est encore rattaché à cet événement.",
      "remove": "Retirer",
      "save_link": "Enregistrer",
      "saved": "Enregistré ✓",
      "update_success": "Lien bénévole mis à jour",
      "registration_approve": "Accepter",
      "registration_reject": "Refuser",
      "registration_approved": "Inscription acceptée",
      "registration_rejected": "Inscription refusée",
      "role_placeholder": "Choisir un poste",
      "primary_role_label": "Rôle principal",
      "remuneration_label": "Rémunération",
      "role_unassigned": "Aucun poste",
      "role_count_one": "{{count}} poste",
      "role_count_other": "{{count}} postes",
      "role_more_one": " +{{count}} autre",
      "role_more_other": " +{{count}} autres",
      "assign_loading": "Mise à jour…",
      "assign_success": "Poste attribué avec succès",
      "status_none": "Sans",
      "status_generated": "Généré",
      "status_sent": "Envoyé",
      "status_signed": "Signé",
      "event_response_label": "Event",
      "event_response_none": "Aucune réponse",
      "shift_response_label": "Shift",
      "shift_response_none": "Aucun shift",
      "shift_response_pending": "En attente",
      "shift_response_confirmed": "Présent confirmé",
      "info_notes": "Notes",
      "info_no_notes": "Aucune note manuscrite",
      "info_max_hours": "Max {{hours}} h",
      "info_rating": "Évaluation : {{rating}}/5",
      "km_reimbursement_label": "Km remboursés",
      "contract_period_start_label": "Début du contrat",
      "contract_period_end_label": "Fin du contrat"
    },
    "package": {
      "chip": "{{tier}} · {{volunteers}} bénévoles",
      "access_until": "Accès complet jusqu'au {{date}}",
      "badge": "Payé",
      "hint": "Cet événement est couvert par son propre forfait."
    }
  },
  "roles": {
    "title": "Postes de l'événement",
    "subtitle": "{{count}} postes sont actuellement configurés pour cet événement.",
    "event_window": "Fenêtre de l'événement",
    "add_button": "Nouveau poste",
    "form_title": "Créer un poste",
    "form_copy": "Définissez des créneaux clairs pour alimenter le planning avec des postes distincts.",
    "batch_title": "Créer plusieurs créneaux d'un coup",
    "batch_copy": "Donnez un nom commun au poste puis ajoutez autant de créneaux que nécessaire pour couvrir la soirée ou le week-end.",
    "form_role_type": "Type de poste",
    "form_role_type_placeholder": "Choisir un type existant",
    "form_role_type_new": "Nouveau type de poste",
    "role_type_create_button": "Créer un type",
    "role_type_use_existing": "Utiliser un type existant",
    "role_type_save": "Enregistrer le type",
    "role_type_create_success": "Type de poste «{{name}}» enregistré",
    "form_name": "Nom du poste",
    "form_description": "Description (optionnelle)",
    "form_start_date": "Date de début",
    "form_end_date": "Date de fin",
    "form_start_time": "Heure de début",
    "form_end_time": "Heure de fin",
    "form_hint": "Le sélecteur x1/x2/x3/x4 crée plusieurs colonnes d'un coup. Chaque colonne devient ensuite un poste distinct.",
    "planner_title": "Composer la couverture du poste",
    "planner_copy": "Peignez les heures à couvrir, choisissez combien de colonnes/postes parallèles il faut, puis générez automatiquement les shifts.",
    "planner_hint": "Faites un drag sur la timeline pour créer une zone. Le sélecteur x1/x2/x3/x4 crée des colonnes visibles pour le vrai nombre de postes simultanés.",
    "planner_granularity": "Pas",
    "planner_granularity_hour": "1h",
    "planner_granularity_half": "30 min",
    "planner_need": "Besoin",
    "planner_lead": "Responsable",
    "planner_lead_label": "Poste responsable",
    "planner_lead_type_placeholder": "N'importe qui",
    "planner_visible_window": "Plage visible",
    "planner_visible_from": "Afficher depuis",
    "planner_visible_to": "Afficher jusqu'à",
    "planner_show_day": "Afficher la grille",
    "planner_hide_day": "Masquer la grille",
    "planner_time_axis": "Timeline",
    "planner_lane": "Poste {{index}}",
    "planner_summary_title": "Zones peintes",
    "planner_summary_copy": "Chaque zone peut avoir son propre nom de poste et sa propre durée de shift.",
    "planner_summary_empty": "Aucune zone de couverture n'a encore été peinte.",
    "planner_summary_need": "{{count}} poste simultané",
    "planner_summary_need_other": "{{count}} postes simultanés",
    "planner_zone_role": "Nom du poste pour cette zone",
    "planner_zone_role_placeholder": "Ex: Chef bar",
    "planner_zone_shift_duration": "Découpe de shift pour cette zone",
    "planner_delete_zone": "Supprimer cette zone",
    "planner_generation_title": "Découper en shifts",
    "planner_generation_copy": "Réglez la durée de shift directement dans chaque zone peinte à gauche, puis générez ou régénérez les shifts ici.",
    "planner_shift_duration_option": "{{count}}h",
    "planner_shift_duration_full": "Tout le shift",
    "planner_generate": "Générer les shifts",
    "planner_generate_again": "Régénérer les shifts",
    "planner_generated_title": "Shifts générés",
    "planner_generated_copy": "Vérifiez, supprimez ou redimensionnez chaque shift généré avant d'enregistrer le poste.",
    "planner_generated_empty": "Aucun shift n'a encore été généré.",
    "planner_generated_footer": "Résumé final de couverture",
    "planner_resize_start": "Début",
    "planner_resize_end": "Fin",
    "planner_extend_earlier": "Étendre plus tôt",
    "planner_shorten_start": "Décaler le début plus tard",
    "planner_shorten_end": "Raccourcir la fin",
    "planner_extend_later": "Étendre plus tard",
    "planner_delete_shift": "Supprimer ce shift",
    "slots_title": "Composer les créneaux",
    "slots_copy": "Empilez les tranches horaires comme un mini planner. Chaque carte décrit un moment précis à couvrir.",
    "form_submit": "Ajouter le poste",
    "add_slot": "Ajouter un créneau",
    "duplicate_slot": "Dupliquer",
    "remove_slot": "Retirer ce créneau",
    "slot_title": "Créneau {{index}}",
    "slot_copy": "Date, heure et effectif pour cette tranche.",
    "slot_overview": "Vue d'ensemble",
    "slot_start": "Début",
    "slot_end": "Fin",
    "slot_staffing": "Effectif",
    "slot_summary_pending": "Créneau à compléter",
    "slot_people": "{{count}} personne requise",
    "slot_people_other": "{{count}} personnes requises",
    "slot_people_pending": "Effectif à préciser",
    "overview_title": "Vue de couverture",
    "overview_copy": "Relisez la couverture directement sur une timeline visuelle avant de descendre dans le détail ligne par ligne.",
    "overview_lane_suffix": "colonne {{index}}",
    "list_title": "Couverture actuelle",
    "list_copy": "La liste est regroupée par poste puis triée par horaire, avec mise en avant des besoins encore sous-staffés.",
    "col_slot": "Ligne",
    "col_name": "Poste",
    "col_schedule": "Horaires",
    "col_required": "Requis",
    "col_assigned": "Assignés",
    "col_actions": "Actions",
    "empty": "Aucun poste n'est encore défini pour cet événement.",
    "description_empty": "Aucune description complémentaire",
    "coverage_complete": "Complet",
    "coverage_partial": "Partiel",
    "coverage_empty": "Vide",
    "coverage_tooltip": "{{assigned}} assignés pour {{required}} requis",
    "schedule_same_day": "Créneau sur une seule date",
    "schedule_multi_day": "Créneau sur plusieurs dates",
    "validation_form": "Complétez le nom, les horaires et un nombre de personnes valide.",
    "validation_role_type": "Ajoutez ou choisissez d'abord un type de poste.",
    "validation_name": "Ajoutez d'abord le nom du poste pour donner une identité commune aux créneaux.",
    "validation_slot_inline": "Certains créneaux doivent encore être corrigés avant l'enregistrement.",
    "validation_slot_form": "Le créneau {{index}} est incomplet ou invalide.",
    "validation_slot_order": "Le créneau {{index}} se termine avant de commencer.",
    "validation_order": "La fin du créneau doit être postérieure au début.",
    "validation_slot_window": "Le créneau {{index}} doit rester dans la fenêtre de l'événement.",
    "validation_window": "Le créneau doit rester dans la fenêtre de l'événement.",
    "validation_planner_empty": "Peignez au moins une zone de couverture avant d'enregistrer le poste.",
    "validation_generate_first": "Générez d'abord les shifts pour pouvoir vérifier la couverture finale du poste.",
    "create_success": "{{count}} poste(s) créé(s) avec succès",
    "delete_button": "Supprimer",
    "delete_title": "Supprimer le poste",
    "delete_copy": "Supprimer {{name}} retirera ce créneau de la liste.",
    "delete_warning": "{{count}} assignment(s) actif(s) sont liés à ce poste. Ils seront supprimés en cascade.",
    "delete_confirm": "Confirmer la suppression",
    "delete_success": "Poste supprimé avec succès",
    "delete_group_button": "Supprimer la grille",
    "delete_group_title": "Supprimer la grille",
    "delete_group_copy": "Supprimer la grille {{name}} retirera {{count}} poste(s) de cette fenêtre.",
    "delete_group_warning": "{{count}} assignment(s) actif(s) sont liés à cette grille. Ils seront supprimés en cascade.",
    "delete_group_confirm": "Confirmer la suppression",
    "delete_group_success": "{{count}} poste(s) supprimé(s) avec succès",
    "delete_group_partial": "{{count}} poste(s) sur {{total}} ont été supprimés avant une erreur.",
    "delete_group_error": "Impossible de supprimer cette grille",
    "assign_title": "Affecter des bénévoles à {{name}}",
    "assign_confirm": "Enregistrer l'affectation",
    "assign_success": "Affectation mise à jour",
    "assign_search_label": "Rechercher un bénévole",
    "assign_search_placeholder": "Rechercher par nom ou email…",
    "assign_search_empty": "Aucun bénévole ne correspond à cette recherche.",
    "assign_available_count": "{{count}} bénévoles rattachés à l'événement",
    "assign_selected_count": "{{count}} / {{required}} sélectionnés",
    "assign_post_count_one": "{{count}} poste au total",
    "assign_post_count_other": "{{count}} postes au total",
    "assign_already_selected": "Déjà affecté à ce poste",
    "assign_capacity_error": "Ce poste est limité à {{count}} personne(s)",
    "assign_unassigned": "À assigner",
    "edit_title": "Modifier le poste",
    "edit_confirm": "Enregistrer les modifications",
    "edit_success": "Poste mis à jour avec succès",
    "edit_warning": "{{count}} assignment(s) actif(s) sont liés à ce poste. Modifier la plage horaire peut les affecter.",
    "edit_role_type_label": "Type de poste",
    "edit_name_label": "Nom du poste",
    "edit_start_label": "Début",
    "edit_end_label": "Fin",
    "edit_description_label": "Description (optionnelle)",
    "edit_contract_template_label": "Modèle de contrat",
    "edit_contract_template_placeholder": "Aucun modèle sélectionné",
    "duplicate_button": "Dupliquer",
    "duplicate_success": "Poste dupliqué. Modifiez la plage horaire pour éviter le chevauchement.",
    "backup_badge": "Renfort",
    "responsible_badge": "Responsable",
    "coverage_title": "Couverture en un coup d'œil",
    "coverage_copy": "Vue rapide du nombre de postes staffés ou encore vides pour cet événement.",
    "coverage_total": "Total",
    "coverage_covered": "Couverts",
    "coverage_empty_count": "Vides",
    "coverage_count": "{{covered}} / {{total}}",
    "coverage_breakdown": "Détail par type de poste",
    "day_windows_button": "Plages horaires",
    "day_windows_title": "Plages horaires par jour",
    "day_windows_copy": "Définissez la fenêtre de temps visible pour chaque jour. Ces plages déterminent ce qui s'affiche dans la timeline de la vue de couverture.",
    "day_windows_col_start": "Début",
    "day_windows_col_end": "Fin",
    "day_windows_save": "Enregistrer",
    "day_windows_saved": "Plages horaires enregistrées"
  },
  "volunteers": {
    "eyebrow": "Équipe",
    "list_title": "Bénévoles",
    "list_subtitle": "Gérez tous les bénévoles de {{name}} depuis une seule surface.",
    "new_title": "Ajouter un bénévole",
    "new_subtitle": "Renseignez les informations pour ajouter un bénévole à votre organisation.",
    "add_volunteer": "Ajouter un bénévole",
    "actions_eyebrow": "Actions",
    "actions_title": "Équipe",
    "stat_total": "Bénévoles",
    "stat_active": "Actifs sur événements",
    "stat_rated": "Bénévoles notés",
    "stat_average_rating": "Note moyenne",
    "breakdown_lead": "Responsables",
    "breakdown_member": "Bénévoles",
    "search_label": "Rechercher un bénévole",
    "search_placeholder": "Rechercher par nom, pseudo ou email…",
    "sort_by": "Trier par :",
    "sort_name": "Nom",
    "sort_rating": "Note",
    "col_name": "Nom",
    "col_email": "Email",
    "col_phone": "Téléphone",
    "col_rating": "Note",
    "loading": "Chargement…",
    "page_info": "Page {{page}} / {{total}}",
    "first_name_label": "Prénom",
    "first_name_placeholder": "Jean",
    "last_name_label": "Nom",
    "last_name_placeholder": "Dupont",
    "email_label": "Email",
    "phone_label": "Téléphone",
    "phone_placeholder": "+32 …",
    "notes_label": "Notes (optionnel)",
    "max_hours_label": "Heures max (optionnel)",
    "max_hours_placeholder": "ex. 6",
    "tags_label": "Tags (optionnel)",
    "tags_placeholder": "bar, securite, logistique",
    "responsible_label": "Responsable",
    "responsible_hint": "Un responsable peut être affecté aux postes responsables, et y est placé en priorité.",
    "rating_label": "Note",
    "rating_clear": "Effacer",
    "show_nickname_label": "Afficher le pseudo sur les horaires papier",
    "show_nickname_hint": "Si activé, le pseudo remplace le nom sur les PDF de planning.",
    "show_nickname_no_nickname_hint": "Ce bénévole n'a pas de pseudo.",
    "nickname_label": "Pseudo (optionnel)",
    "nickname_placeholder": "ex. Johnny",
    "nickname_too_short": "Le pseudo doit comporter au moins 4 caractères",
    "personal_info_admin": "Informations administratives",
    "national_number_label": "Numéro national",
    "national_number_placeholder": "00.00.00-000.00",
    "bank_account_label": "Compte bancaire (IBAN)",
    "bank_account_placeholder": "BE00 0000 0000 0000",
    "personal_info_address": "Adresse",
    "address_street_label": "Rue",
    "address_street_placeholder": "Rue de la Loi",
    "address_number_label": "N°",
    "address_zip_label": "Code postal",
    "address_city_label": "Ville",
    "address_country_label": "Pays",
    "address_country_placeholder": "BE",
    "notes_placeholder": "Disponibilités, compétences, remarques…",
    "first_name_required": "Le prénom est requis",
    "last_name_required": "Le nom est requis",
    "email_required": "L'email est requis",
    "email_invalid": "L'email est invalide",
    "phone_required": "Le téléphone est requis",
    "phone_invalid": "Le numéro de téléphone est invalide",
    "no_organisation": "Aucune organisation active sélectionnée",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "create_success": "Bénévole ajouté avec succès",
    "edit": "Modifier",
    "edit_title": "Modifier le bénévole",
    "update_success": "Bénévole mis à jour avec succès",
    "delete": "Supprimer",
    "delete_title": "Supprimer le bénévole",
    "delete_copy": "Supprimer {{name}} de votre base bénévole.",
    "delete_data_hint": "Ses données personnelles (coordonnées, numéro national, compte bancaire, adresse, photo) sont effacées. Les contrats déjà générés ou signés et leurs écritures comptables sont conservés, sans son nom.",
    "delete_confirm": "Confirmer la suppression",
    "delete_success": "Bénévole supprimé avec succès",
    "delete_assignments_warning": "{{count}} assignment(s) actif(s) disparaîtront aussi avec ce bénévole.",
    "delete_no_assignments": "Aucun assignment actif n'est lié à ce bénévole.",
    "import_button": "Importer CSV",
    "import_title": "Importer des bénévoles",
    "import_copy": "Chargez un CSV avec les colonnes first_name, last_name, email et phone.",
    "import_file_label": "Fichier CSV",
    "import_preview_title": "Aperçu (10 premières lignes)",
    "import_preview_empty": "Sélectionnez un fichier CSV pour prévisualiser l'import.",
    "import_preview_error": "Impossible de générer l'aperçu CSV. Vérifiez les colonnes attendues.",
    "import_submit": "Importer les bénévoles",
    "import_success": "{{imported}} importés, {{skipped}} ignorés",
    "import_report_imported": "{{count}} importés",
    "import_report_skipped": "{{count}} ignorés",
    "import_line": "Ligne",
    "col_actions": "Actions"
  },
  "planning": {
    "title": "Planning",
    "subtitle": "Générez automatiquement les assignments optimaux pour cet événement.",
    "generate_button": "Générer le planning",
    "regenerate_button": "Regénérer",
    "regenerate_title": "Regénérer le planning",
    "regenerate_copy": "Êtes-vous sûr de vouloir relancer la génération du planning ?",
    "regenerate_warning": "Les assignments générés automatiquement seront remplacés. Les assignments manuels seront conservés.",
    "regenerate_confirm": "Confirmer la regénération",
    "generating": "Calcul en cours… (peut prendre jusqu'à 30 secondes)",
    "empty": "Aucun planning généré. Cliquez sur \"Générer le planning\" pour commencer.",
    "preconditions_warning": "Les conditions préalables ne sont pas remplies :",
    "precondition_no_roles": "Aucun poste défini pour cet événement",
    "precondition_no_volunteers": "Aucun bénévole ajouté à cet événement",
    "stat_score": "Score",
    "stat_total_roles": "Postes totaux",
    "stat_covered_roles": "Postes couverts",
    "stat_assigned": "Bénévoles assignés",
    "stat_unassigned": "Non assignés",
    "score_unknown": "–",
    "unassigned_title": "Bénévoles non assignés",
    "unassigned_copy": "Ces bénévoles n'ont pas pu être placés sur un poste. Voici pourquoi.",
    "unassigned_show_more": "Voir plus ({{count}})",
    "unassigned_show_less": "Voir moins",
    "conflicts_title": "Conflits détectés",
    "volunteer_id_label": "Bénévole",
    "config_title": "Configuration de l'algorithme",
    "config_copy": "Paramètres utilisés lors de la prochaine génération.",
    "config_max_hours": "Heures max par bénévole",
    "config_max_hours_help": "Plafond d'heures attribuées à un bénévole sur l'événement. Une limite individuelle définie sur sa fiche reste prioritaire.",
    "config_min_break": "Pause minimum (minutes)",
    "config_min_break_help": "Repos minimum imposé entre deux créneaux d'un même bénévole avant de pouvoir le réassigner.",
    "config_max_continuous": "Temps continu max (minutes)",
    "config_max_continuous_help": "Temps maximum qu'un bénévole peut enchaîner sans pause (les shifts plus rapprochés que la pause minimum comptent comme un seul bloc). Un shift unique plus long n'est jamais coupé. 0 = sans limite.",
    "config_prioritize_rating": "Prioriser par note",
    "config_save": "Enregistrer la configuration",
    "coverage_title": "Vue de couverture",
    "coverage_copy": "Vue en temps réel des affectations de rôles générées par le planning.",
    "vacated_shifts": {
      "title": "Postes libérés",
      "copy": "Postes qu'un bénévole a libérés en les refusant ou en quittant l'événement. Réaffectez-les pour garder votre planning complet.",
      "empty": "Aucun poste libéré pour le moment.",
      "reason_decline": "Bénévole a refusé",
      "reason_unregister": "A quitté l'événement",
      "reason_unknown": "Libéré",
      "reason_note": "Raison : {{reason}}"
    },
    "regenerate_keep_button": "Regénérer en conservant",
    "regenerate_keep_title": "Regénérer (en conservant)",
    "regenerate_keep_copy": "Les postes non couverts seront complétés tout en conservant les affectations existantes.",
    "regenerate_keep_confirm": "Confirmer",
    "delete_button": "Supprimer le planning",
    "delete_title": "Supprimer le planning",
    "delete_copy": "Voulez-vous vraiment supprimer le planning généré pour cet événement ?",
    "delete_warning": "Toutes les affectations générées automatiquement et les résultats de planning seront supprimés. Les affectations manuelles seront conservées.",
    "delete_confirm": "Confirmer la suppression",
    "delete_success": "Planning supprimé",
    "publish": {
      "published_title": "Horaire publié",
      "published_copy": "Visible des bénévoles depuis le {{date}}.",
      "draft_title": "Horaire en brouillon",
      "draft_copy": "Non visible des bénévoles tant qu'il n'est pas publié.",
      "publish_button": "Publier l'horaire",
      "unpublish_button": "Dépublier",
      "publish_success": "Horaire publié — les bénévoles peuvent maintenant le voir",
      "unpublish_success": "Horaire dépublié — il n'est plus visible des bénévoles"
    },
    "send_schedule": {
      "send_button": "Envoyer l'horaire",
      "resend_button": "Renvoyer à tous",
      "success": "Horaire envoyé à {{sent}} bénévole(s), {{skipped}} ignoré(s)."
    },
    "edit_volunteer_title": "Modifier — {{name}}",
    "edit_availability_section": "Disponibilités",
    "edit_preferences_section": "Préférences de rôles",
    "reasons": {
      "no_availability": {
        "label": "Aucune disponibilité",
        "detail": "Ce bénévole n'a saisi aucune disponibilité pour cet événement."
      },
      "no_matching_slot": {
        "label": "Aucun créneau compatible",
        "detail": "Les disponibilités du bénévole ne couvrent entièrement aucun créneau de poste."
      },
      "type_mismatch": {
        "label": "Type incompatible",
        "detail": "Le type du bénévole ne correspond à aucun poste pour lequel il est disponible."
      },
      "max_hours_reached": {
        "label": "Limite d'heures atteinte",
        "detail": "Le budget d'heures est trop faible pour caser le moindre poste que ce bénévole pourrait prendre."
      },
      "break_conflict": {
        "label": "Conflit de pause",
        "detail": "Des chevauchements ou la pause minimale entre créneaux bloquent tous les postes restants."
      },
      "all_roles_filled": {
        "label": "Tous les postes pourvus",
        "detail": "Tous les postes que ce bénévole pouvait prendre étaient déjà couverts par d'autres bénévoles."
      },
      "invalid_assignment": {
        "label": "Affectation invalide",
        "detail": "Une affectation existante a été rejetée car elle ne respecte plus les exigences du poste."
      },
      "unknown": {
        "label": "Raison inconnue",
        "detail": "Le planificateur n'a pas fourni de raison reconnue."
      }
    },
    "export_pdf": "Exporter en PDF",
    "table": {
      "title": "Tableau du planning",
      "copy": "Qui fait quoi et quand, par poste et par créneau.",
      "empty": "Aucun poste défini pour cet événement.",
      "uncovered": "Non assigné",
      "col_role": "Poste",
      "col_slot": "Créneau",
      "col_volunteers": "Bénévole(s)",
      "col_status": "Statut",
      "status_covered": "Couvert",
      "status_empty": "À pourvoir"
    },
    "volunteer_hours": {
      "title": "Heures par bénévole",
      "copy": "Total d'heures et de créneaux assignés à chaque bénévole.",
      "empty": "Aucun bénévole assigné pour le moment.",
      "col_volunteer": "Bénévole",
      "col_shifts": "Créneaux",
      "col_hours": "Heures"
    }
  },
  "availabilities": {
    "title": "Disponibilités",
    "col_header": "Paramètres",
    "show": "Disponibilités",
    "hide": "Masquer",
    "empty": "Aucun créneau défini",
    "add": "Ajouter un créneau",
    "delete": "Supprimer",
    "date": "Date",
    "start_time": "Heure de début",
    "end_time": "Heure de fin",
    "full_event": "Tout l'événement",
    "full_day": "Disponible toute la journée",
    "clear_all": "Tout effacer",
    "save": "Sauvegarder",
    "timeline_title": "Vue des disponibilités",
    "timeline_empty": "Aucune disponibilité enregistrée",
    "timeline_expand": "Voir tout",
    "timeline_collapse": "Voir moins",
    "coverage": "Couverture",
    "save_success": "Disponibilités enregistrées",
    "coverage_complete": "Couverture complète"
  },
  "contracts": {
    "templates": {
      "eyebrow": "Configuration",
      "title": "Modèles de contrats",
      "subtitle": "Importez un PDF dans Documenso et réutilisez-le comme modèle de signature pour vos événements.",
      "restore_starter": "Restaurer le brouillon type",
      "editor_hint": "Le contenu est stocké dans votre backend puis transformé en PDF pour Documenso. Gardez un bloc de signature en bas du document et utilisez {{placeholder}} là où la signature de l'organisation doit apparaître.",
      "editor_placeholder": "Rédigez ici le contenu du contrat...",
      "form_title": "Nouveau modèle",
      "edit_title": "Modifier le modèle",
      "new_template": "Nouveau modèle",
      "library_eyebrow": "Bibliothèque",
      "editor_eyebrow": "Modèle",
      "name_label": "Nom du modèle",
      "name_placeholder": "ex. Contrat bénévole standard",
      "pdf_label": "PDF du contrat",
      "pdf_hint": "Le PDF sera importé dans Documenso comme modèle de signature.",
      "pdf_placeholder": "Cliquez pour sélectionner un fichier PDF",
      "edit_pdf_hint": "Pour remplacer le PDF, créez un nouveau modèle.",
      "submit": "Créer le modèle",
      "save_changes": "Enregistrer les modifications",
      "reset": "Annuler",
      "list_title": "Modèles existants",
      "has_documenso_template": "Lié à Documenso",
      "no_documenso_template": "Pas de modèle de signature",
      "empty": "Aucun modèle créé pour le moment.",
      "col_name": "Nom",
      "col_status": "Statut",
      "status_active": "Actif",
      "status_inactive": "Inactif",
      "create_success": "Modèle créé avec succès",
      "update_success": "Modèle mis à jour avec succès",
      "validation_required": "Le nom du modèle est requis",
      "validation_content_required": "Le contenu du contrat est requis",
      "validation_pdf_only": "Seuls les fichiers PDF sont acceptés",
      "validation_pdf_required": "Un fichier PDF est requis pour créer un modèle",
      "variables_eyebrow": "Variables",
      "variables_title": "Placeholders disponibles",
      "variables_copy": "Cliquez sur une variable pour l'insérer dans le contrat. Elle sera remplacée par les données réelles lors de la génération / signature."
    },
    "dashboard": {
      "stat_total": "Bénévoles",
      "stat_generated": "Générés",
      "stat_sent": "Envoyés",
      "stat_signed": "Signés",
      "col_name": "Nom",
      "col_email": "Email",
      "col_role": "Poste",
      "col_remuneration": "Rémunération",
      "col_status": "Statut",
      "col_sent_at": "Envoyé le",
      "col_signed_at": "Signé le",
      "col_reminders": "Relances",
      "auto_reminders_label": "Relances automatiques",
      "auto_reminders_on": "Relances automatiques activées",
      "auto_reminders_off": "Relances automatiques désactivées",
      "col_signing_link": "Lien de signature",
      "col_actions": "Actions",
      "status_none": "Sans",
      "status_generated": "Généré",
      "status_sent": "Envoyé",
      "status_signed": "Signé",
      "filter_label": "Filtrer par statut",
      "filter_all": "Tous les statuts",
      "generate_btn": "Générer",
      "generate_all_btn": "Tout générer",
      "send_btn": "Envoyer",
      "send_all_btn": "Tout envoyer",
      "remind_btn": "Relancer les non-signataires",
      "download_btn": "Télécharger",
      "copy_sign_link_btn": "Copier le lien de signature",
      "link_copied": "Lien copié dans le presse-papier",
      "sign_link_pending": "Lien en attente",
      "sign_link_pending_tooltip": "La soumission Documenso existe mais le lien de signature n'a pas encore été résolu.",
      "resend_btn": "Renvoyer",
      "regenerate_btn": "Regénérer le PDF",
      "no_email_tooltip": "Ce bénévole n'a pas d'adresse email",
      "empty": "Aucun bénévole rattaché à cet événement.",
      "search_placeholder": "Rechercher par nom ou email…",
      "search_empty": "Aucun contrat ne correspond à cette recherche.",
      "generate_success": "Contrat généré avec succès",
      "generate_all_success": "{{count}} contrat(s) généré(s), {{skipped}} ignoré(s)",
      "generate_all_progress": "Génération {{done}} / {{total}}…",
      "generate_all_empty": "Aucun contrat à générer",
      "generate_all_error": "Échec de la génération groupée des contrats",
      "send_success": "Contrat envoyé avec succès",
      "send_all_success": "{{sent}} contrat(s) envoyé(s), {{skipped}} ignoré(s)",
      "remind_title": "Relancer les non-signataires",
      "remind_copy": "{{count}} bénévole(s) recevront un email de relance. Confirmer ?",
      "remind_confirm": "Envoyer les relances",
      "remind_success": "{{count}} relance(s) envoyée(s)",
      "no_template_tooltip": "Aucun modèle de contrat attribué — cliquez pour en choisir un",
      "regenerate_signed_title": "Contrat déjà signé",
      "regenerate_signed_copy": "Le contrat de {{name}} a déjà été signé. Le régénérer remplacera la version signée. Êtes-vous sûr ?",
      "regenerate_signed_confirm": "Régénérer quand même"
    },
    "list": {
      "eyebrow": "Suivi",
      "title": "Contrats — {{name}}",
      "subtitle": "Suivez chaque contrat de bénévole, lié à un événement ou non, et voyez d'un coup d'œil ce qui est signé et ce qui reste en attente.",
      "stat_total": "Total",
      "stat_generated": "Générés",
      "stat_sent": "Envoyés",
      "stat_signed": "Signés",
      "filters_eyebrow": "Filtres",
      "filters_title": "Trouver un contrat",
      "filter_status_label": "Statut",
      "filter_status_all": "Tous les statuts",
      "filter_event_label": "Événement",
      "filter_event_all": "Tous les événements",
      "search_label": "Rechercher un bénévole",
      "search_placeholder": "Nom ou e-mail",
      "new_contract": "Nouveau contrat",
      "col_volunteer": "Bénévole",
      "col_attachment": "Rattaché à",
      "col_status": "Statut",
      "col_period": "Période",
      "col_sent_at": "Envoyé le",
      "col_signed_at": "Signé le",
      "col_actions": "Actions",
      "col_signing_link": "Lien de signature",
      "copy_link_btn": "Copier le lien",
      "link_pending": "Lien en attente",
      "link_pending_tooltip": "La soumission de signature existe mais le lien n'est pas encore disponible.",
      "link_copied": "Lien copié dans le presse-papier",
      "standalone": "Hors-événement",
      "status_none": "Non généré",
      "status_generated": "Généré",
      "status_sent": "Envoyé",
      "status_signed": "Signé",
      "empty": "Aucun contrat ne correspond à ces filtres.",
      "generate_btn": "Générer",
      "send_btn": "Envoyer",
      "resend_btn": "Renvoyer",
      "regenerate_btn": "Régénérer",
      "download_btn": "Télécharger le PDF signé",
      "delete_btn": "Supprimer",
      "no_email": "Ce bénévole n'a pas d'adresse e-mail",
      "no_template": "Aucun modèle de contrat configuré. Définissez d'abord un modèle par défaut pour l'organisation.",
      "generate_success": "Contrat généré avec succès",
      "send_success": "Contrat envoyé avec succès",
      "delete_success": "Contrat supprimé",
      "delete_title": "Supprimer ce contrat",
      "delete_copy": "Le contrat hors-événement de {{name}} sera définitivement supprimé. Continuer ?",
      "delete_confirm": "Supprimer",
      "regenerate_signed_title": "Contrat déjà signé",
      "regenerate_signed_copy": "Le contrat de {{name}} a déjà été signé. Le régénérer remplacera la version signée. Continuer ?",
      "regenerate_signed_confirm": "Régénérer quand même"
    },
    "create": {
      "title": "Nouveau contrat hors-événement",
      "copy": "Créez un contrat pour un bénévole sans le rattacher à un événement.",
      "volunteer_label": "Bénévole",
      "volunteer_placeholder": "Sélectionner un bénévole",
      "template_label": "Modèle de contrat",
      "template_placeholder": "Modèle par défaut de l'organisation",
      "mission_label": "Mission",
      "mission_placeholder": "ex. Service au bar — soirée privée",
      "remuneration_label": "Rémunération (€)",
      "km_label": "Km à rembourser",
      "period_start_label": "Date de début",
      "period_end_label": "Date de fin",
      "periods_label": "Périodes",
      "add_period": "Ajouter une période",
      "remove_period": "Supprimer cette période",
      "submit": "Créer le contrat",
      "success": "Contrat créé avec succès",
      "validation_volunteer": "Veuillez sélectionner un bénévole",
      "validation_mission": "La mission est obligatoire"
    }
  },
  "preferences": {
    "title": "Préférences de postes",
    "subtitle": "Cliquez sur un type de poste pour indiquer si le bénévole le souhaite ou veut l'éviter.",
    "want": "Souhaité",
    "avoid": "À éviter",
    "neutral": "Neutre",
    "no_role_types": "Aucun type de poste défini pour cet événement.",
    "locked_hint": "Ce poste requiert un type de bénévole spécifique — non disponible pour ce bénévole."
  },
  "cookies": {
    "aria_label": "Consentement aux cookies",
    "title": "Votre vie privée compte",
    "description": "Nous utilisons des cookies pour vous garder connecté, mesurer l'usage et améliorer Coval Flow. Vous décidez de ce que vous autorisez.",
    "customize": "Personnaliser",
    "accept_all": "Tout accepter",
    "reject_all": "Tout refuser",
    "save": "Enregistrer mes choix",
    "category_necessary": "Strictement nécessaires",
    "category_necessary_desc": "Indispensables à la connexion, à la sécurité et aux fonctions de base.",
    "category_necessary_badge": "Toujours actifs",
    "category_analytics": "Analyse d'audience",
    "category_analytics_desc": "Nous aident à comprendre l'usage de l'espace de travail pour l'améliorer.",
    "category_marketing": "Marketing",
    "category_marketing_desc": "Permettent de personnaliser le contenu et de mesurer les campagnes.",
    "policy_link": "En savoir plus — Politique cookies",
    "reopen_aria": "Préférences cookies"
  },
  "cookiePolicy": {
    "back": "Retour à l'accueil",
    "title": "Politique cookies",
    "updated": "Dernière mise à jour : mai 2026",
    "intro": "Cette politique explique comment Coval Flow utilise les cookies et technologies similaires, et comment vous pouvez les contrôler. Vous pouvez à tout moment accepter, refuser ou paramétrer les cookies non essentiels.",
    "what_title": "Qu'est-ce qu'un cookie ?",
    "what_body": "Un cookie est un petit fichier enregistré sur votre appareil lors de la visite d'un site. Des technologies similaires comme le localStorage fonctionnent de la même façon. Ils permettent à l'application de fonctionner correctement, de mémoriser vos choix et — uniquement avec votre consentement — de mesurer l'usage.",
    "categories_title": "Catégories de cookies utilisées",
    "necessary_title": "Cookies strictement nécessaires",
    "necessary_body": "Indispensables pour vous connecter, sécuriser votre session et faire fonctionner les fonctions de base. Ils ne peuvent pas être désactivés car le service ne fonctionnerait pas sans eux, et ils sont exemptés de consentement.",
    "analytics_title": "Cookies d'analyse d'audience",
    "analytics_body": "Nous aident à comprendre l'usage de l'espace de travail afin de l'améliorer. Ils ne sont déposés qu'après votre consentement et peuvent être refusés sans incidence sur votre utilisation de l'application.",
    "marketing_title": "Cookies marketing",
    "marketing_body": "Permettent de personnaliser le contenu et de mesurer les campagnes. Ils ne sont déposés qu'après votre consentement et ne sont jamais nécessaires pour utiliser le service.",
    "manage_title": "Gérer vos préférences",
    "manage_body": "Vous pouvez modifier ou retirer votre consentement à tout moment. Rouvrez le panneau cookies ci-dessous, ou utilisez le bouton cookie affiché en bas à gauche de chaque page.",
    "manage_button": "Gérer les préférences cookies",
    "retention_title": "Combien de temps votre choix est-il conservé ?",
    "retention_body": "Votre choix de consentement est conservé sur votre appareil pendant 6 mois maximum. Passé ce délai, ou si cette politique évolue, la bannière cookies réapparaît afin que vous puissiez décider à nouveau. Une trace horodatée de chaque décision est également conservée à titre de preuve du consentement.",
    "rights_title": "Vos droits",
    "rights_body": "Conformément au RGPD, vous pouvez accéder à vos données personnelles, les rectifier ou les effacer, et retirer votre consentement aussi facilement que vous l'avez donné. Refuser les cookies non essentiels n'a aucune conséquence négative sur votre utilisation du service.",
    "contact_title": "Contact",
    "contact_body": "Pour toute question relative à cette politique ou pour exercer vos droits, contactez l'organisation qui exploite cet espace de travail. Remplacez cette section par les coordonnées de votre responsable de traitement et de votre DPO avant toute mise en production."
  },
  "termsOfUse": {
    "back": "Retour à l'accueil",
    "title": "Conditions d'utilisation",
    "updated": "Dernière mise à jour : mai 2026",
    "intro": "Les présentes conditions d'utilisation régissent votre accès à Coval Flow et votre utilisation du service. En créant un compte ou en utilisant l'espace de travail, vous acceptez ces conditions. Merci de les lire attentivement.",
    "scope_title": "Objet du service",
    "scope_body": "Coval Flow est un espace de travail en ligne qui aide les organisateurs d'événements à recruter des bénévoles, à construire le planning des créneaux et à générer et signer des contrats. Le service est fourni en l'état et peut évoluer avec l'ajout de nouvelles fonctionnalités.",
    "eligibility_title": "Éligibilité et comptes",
    "eligibility_body": "Vous devez avoir au moins 18 ans et être en capacité de conclure un contrat pour créer un compte organisateur. Vous êtes responsable de l'exactitude des informations de votre compte et de la confidentialité de vos identifiants. Vous répondez de toutes les actions effectuées depuis votre compte.",
    "acceptable_title": "Utilisation acceptable",
    "acceptable_body": "Vous vous engagez à ne pas détourner le service, à ne pas tenter de le perturber, à ne pas y accéder par des moyens non autorisés et à ne pas l'utiliser à des fins illicites. Vous ne devez pas téléverser de contenu portant atteinte aux droits de tiers ou que vous n'êtes pas autorisé à partager.",
    "volunteer_data_title": "Données des bénévoles et responsabilités",
    "volunteer_data_body": "Lorsque vous ajoutez des bénévoles à votre organisation, vous agissez en tant que responsable du traitement de leurs données personnelles. Il vous appartient de disposer d'une base légale pour ce traitement, d'informer les bénévoles et de respecter leurs droits. Coval Flow ne traite ces données que pour fournir le service.",
    "contracts_title": "Contrats et signatures électroniques",
    "contracts_body": "Les fonctionnalités de génération de contrats et de signature électronique sont des outils destinés à vous aider à formaliser vos accords avec les bénévoles. Vous restez seul responsable du contenu, de la légalité et de la valeur juridique des documents que vous créez et envoyez. Coval Flow n'est pas partie à ces accords.",
    "availability_title": "Disponibilité et évolution du service",
    "availability_body": "Nous nous efforçons de maintenir le service disponible et fiable, mais nous ne pouvons pas garantir un accès ininterrompu. Nous pouvons faire évoluer, suspendre ou retirer des fonctionnalités, et nous vous informerons dans un délai raisonnable des changements importants lorsque cela est possible.",
    "changes_title": "Modification des présentes conditions",
    "changes_body": "Nous pouvons mettre à jour ces conditions d'utilisation pour refléter les évolutions du service ou pour des raisons légales. En cas de changement substantiel, nous vous en informerons et mettrons à jour la date indiquée ci-dessus. Continuer à utiliser le service après une modification vaut acceptation des conditions révisées.",
    "contact_title": "Contact",
    "contact_body": "Pour toute question relative aux présentes conditions d'utilisation, contactez l'organisation qui exploite cet espace de travail. Remplacez cette section par votre entité juridique et vos coordonnées avant toute mise en production."
  },
  "tour": {
    "start_button": "Aide / Faire la visite guidée",
    "step_profile_title": "Bienvenue dans votre espace bénévole !",
    "step_profile_desc": "Voici votre tableau de bord personnel. Vous y retrouvez votre photo de profil, vos coordonnées et un résumé de votre activité.",
    "step_stats_title": "Votre activité en un coup d'œil",
    "step_stats_desc": "Ces quatre compteurs indiquent vos shifts à venir, vos inscriptions aux événements, vos documents disponibles et vos shifts passés — mis à jour en temps réel.",
    "step_nav_title": "Naviguez entre les sections",
    "step_nav_desc": "Utilisez ces onglets pour passer entre vos différents espaces : Préférences, À venir, Événements, Documents et Passés.",
    "step_upcoming_title": "Vos shifts à venir",
    "step_upcoming_desc": "Tous vos postes assignés apparaissent ici. Confirmez votre présence ou signalez une indisponibilité directement depuis cette liste.",
    "step_events_title": "Événements disponibles",
    "step_events_desc": "Inscrivez-vous aux événements qui vous intéressent, puis renseignez vos disponibilités pour que l'organisateur puisse vous assigner aux bons shifts.",
    "step_documents_title": "Vos documents",
    "step_documents_desc": "Tous les documents partagés par l'organisation sont regroupés ici. Téléchargez vos fichiers ou signez un document directement depuis cette page.",
    "step_preferences_title": "Vos préférences",
    "step_preferences_desc": "Définissez le nombre maximum d'heures que vous pouvez prester et choisissez les rôles que vous préférez ou voulez éviter. Cela aide l'organisateur à constituer la meilleure équipe.",
    "step_end_title": "Vous êtes prêt(e) !",
    "step_end_desc": "Vous savez maintenant comment naviguer dans votre espace bénévole. Vous pouvez relancer cette visite à tout moment en cliquant sur le bouton '?' dans la carte du haut.",
    "next": "Suivant",
    "prev": "Retour",
    "done": "Compris !"
  },
  "landing": {
    "seo_title": "Coval Flow — Gérez événements, bénévoles et contrats",
    "seo_description": "Coval Flow est l'espace de travail tout-en-un des organisateurs d'événements : recrutez vos bénévoles, générez le planning automatiquement et faites signer les contrats en ligne.",
    "nav": {
      "features": "Fonctionnalités",
      "how": "Comment ça marche",
      "pricing": "Tarifs",
      "faq": "FAQ",
      "login": "Se connecter",
      "signup": "S'inscrire",
      "workspace": "Mon espace",
      "volunteer_access": "Bénévole",
      "menu_aria": "Ouvrir le menu"
    },
    "hero": {
      "eyebrow": "Plateforme de gestion d'événements",
      "title": "Gérez vos événements et vos bénévoles",
      "title_highlight": "sans les tableurs.",
      "subtitle": "Coval Flow réunit le recrutement de bénévoles, la planification automatique des shifts et la signature de contrats dans un seul espace de travail pensé pour les organisateurs.",
      "cta_primary": "Commencer gratuitement",
      "cta_secondary": "Voir les tarifs",
      "note": "Gratuit pour votre premier événement. Sans carte bancaire.",
      "stats": [
        {
          "value": "1 clic",
          "label": "pour un planning complet"
        },
        {
          "value": "100 %",
          "label": "de contrats sans papier"
        },
        {
          "value": "FR / EN",
          "label": "espace bilingue"
        }
      ]
    },
    "features": {
      "eyebrow": "Tout au même endroit",
      "title": "Un seul espace pour tout l'événement",
      "subtitle": "Fini les tableurs, les groupes de discussion et les contrats papier. Coval Flow relie chaque rouage de votre événement.",
      "items": [
        {
          "title": "Événements",
          "desc": "Centralisez chaque édition — dates, lieu, visuel et statut — sur un tableau de bord unique."
        },
        {
          "title": "Bénévoles",
          "desc": "Construisez une base de bénévoles propre : import CSV, types, évaluations, notes et disponibilités."
        },
        {
          "title": "Rôles & couverture",
          "desc": "Dessinez les heures à couvrir sur une timeline visuelle et transformez-les en shifts."
        },
        {
          "title": "Planning automatique",
          "desc": "Un algorithme assigne le bon bénévole à chaque poste, en respectant disponibilités et pauses."
        },
        {
          "title": "Contrats & signature",
          "desc": "Générez les contrats depuis vos modèles, envoyez-les et récoltez les signatures en ligne."
        },
        {
          "title": "Espace bénévole",
          "desc": "Chaque bénévole dispose de son espace pour suivre ses shifts, confirmer sa présence et signer."
        }
      ]
    },
    "how": {
      "eyebrow": "Comment ça marche",
      "title": "De l'idée à l'événement staffé en quatre étapes",
      "subtitle": "Coval Flow garde tout le flux dans un seul outil — fini les allers-retours entre tableurs et boîtes mail.",
      "steps": [
        {
          "title": "Créez votre événement",
          "desc": "Renseignez les dates, le lieu et importez votre base de bénévoles en quelques minutes."
        },
        {
          "title": "Définissez les rôles",
          "desc": "Dessinez les shifts et les postes à couvrir pour chaque journée."
        },
        {
          "title": "Générez le planning",
          "desc": "Laissez l'algorithme construire une affectation optimale, puis ajustez-la."
        },
        {
          "title": "Envoyez les contrats",
          "desc": "Générez, envoyez et suivez chaque signature sans quitter l'application."
        }
      ]
    },
    "showcase": {
      "items": [
        {
          "eyebrow": "Tableau de bord",
          "title": "Pilotez chaque événement depuis un seul tableau de bord",
          "desc": "Visualisez le recrutement, la couverture des rôles et l'avancement des contrats pour tous vos événements — et ouvrez-en un en un clic.",
          "bullets": [
            "Compteurs en direct : bénévoles, couverture, contrats",
            "Statuts brouillon, actif, terminé et archivé",
            "Un tableau lisible, même en pleine saison"
          ]
        },
        {
          "eyebrow": "Planning automatique",
          "title": "Un planning optimal, généré en un clic",
          "desc": "Le moteur associe les bénévoles aux postes selon les disponibilités, les types de rôle, les limites d'heures et les pauses — et explique chaque bénévole non assigné.",
          "bullets": [
            "Timeline de couverture avec postes simultanés",
            "Disponibilités et préférences de rôle prises en compte",
            "Une raison claire dès qu'un bénévole ne peut pas être placé"
          ]
        },
        {
          "eyebrow": "Contrats & signature",
          "title": "Des contrats signés, sans relancer personne",
          "desc": "Générez les contrats depuis vos propres modèles, envoyez-les par e-mail et suivez chaque signature. Les relances automatiques s'en chargent pour vous.",
          "bullets": [
            "Modèles de contrats réutilisables avec variables",
            "Signature en ligne et téléchargement du PDF signé",
            "Relances automatiques des non-signataires"
          ]
        }
      ]
    },
    "pricing_preview": {
      "eyebrow": "Tarifs",
      "title": "Payez à l'événement, ou à l'année",
      "subtitle": "Lancez votre premier événement gratuitement. Ensuite, payez uniquement l'événement que vous organisez, ou prenez un abonnement si vous en enchaînez plusieurs.",
      "event_note": "Vous n'organisez qu'un événement par an ? Formule à l'événement à partir de {{price}} €, en paiement unique et sans abonnement.",
      "cta": "Comparer toutes les fonctionnalités"
    },
    "faq": {
      "eyebrow": "FAQ",
      "title": "Questions fréquentes",
      "items": [
        {
          "q": "Coval Flow est-il vraiment gratuit au départ ?",
          "a": "Oui. Le plan Gratuit vous permet d'organiser votre premier événement avec jusqu'à 10 bénévoles, sans carte bancaire et sans limite de durée."
        },
        {
          "q": "Que se passe-t-il quand j'ai plus d'événements ?",
          "a": "Vous avez le choix : payer uniquement l'événement suivant, à partir de 49 €, ou prendre un abonnement pour des événements illimités toute l'année. À partir de trois événements par an, l'abonnement revient moins cher."
        },
        {
          "q": "Comment fonctionne la signature des contrats ?",
          "a": "Vous rédigez vos modèles de contrats une fois, Coval Flow les transforme en PDF et récolte les signatures en ligne. Les documents signés sont stockés et téléchargeables."
        },
        {
          "q": "Les bénévoles ont-ils besoin d'un compte ?",
          "a": "Les bénévoles disposent de leur propre espace pour voir leurs shifts, confirmer leur présence et signer. Vous partagez un seul lien d'inscription avec votre équipe."
        },
        {
          "q": "La plateforme est-elle disponible en français ?",
          "a": "Oui. Tout l'espace de travail — et l'espace bénévole — est disponible en français et en anglais."
        },
        {
          "q": "Où sont hébergées mes données ?",
          "a": "Vos données restent dans un espace de travail sécurisé, propre à votre organisation. Seuls les membres que vous invitez y ont accès."
        }
      ]
    },
    "cta": {
      "title": "Prêt à organiser votre prochain événement ?",
      "subtitle": "Créez votre espace de travail en quelques minutes et organisez votre premier événement gratuitement.",
      "primary": "Commencer gratuitement",
      "secondary": "Voir les tarifs",
      "note": "Sans carte bancaire."
    },
    "footer": {
      "tagline": "L'espace de travail des organisateurs d'événements — bénévoles, planning et contrats au même endroit.",
      "product": "Produit",
      "account": "Compte",
      "resources": "Ressources",
      "links": {
        "features": "Fonctionnalités",
        "how": "Comment ça marche",
        "pricing": "Tarifs",
        "faq": "FAQ",
        "signup": "Créer un compte",
        "login": "Se connecter",
        "volunteer_portal": "Espace bénévole",
        "contact": "Nous contacter",
        "cookies": "Politique de cookies",
        "terms": "Conditions d'utilisation"
      },
      "rights": "© {{year}} Coval Flow. Tous droits réservés."
    },
    "preview": {
      "dashboard_title": "Vue des événements",
      "stat_events": "Événements",
      "stat_volunteers": "Bénévoles",
      "stat_coverage": "Couverture",
      "stat_contracts": "Contrats",
      "status_active": "Actif",
      "status_draft": "Brouillon",
      "planning_title": "Planning",
      "planning_score": "Score",
      "contracts_title": "Contrats",
      "status_signed": "Signé",
      "status_sent": "Envoyé",
      "status_generated": "Généré",
      "role_bar": "Bar",
      "role_welcome": "Accueil",
      "role_security": "Sécurité",
      "role_stage": "Scène"
    }
  },
  "upgrade": {
    "badge": "Pro",
    "badge_hint": "Cette fonctionnalité fait partie de l'offre Pro",
    "title": "Vous avez atteint la limite de votre offre",
    "reason": {
      "active_events": "Événements actifs : {{current}} sur {{limit}}. Votre offre actuelle ne permet pas d'aller plus loin.",
      "volunteers_per_event": "Cet événement compte {{current}} bénévoles, votre offre en couvre {{limit}}.",
      "team_members": "Membres d'équipe : {{current}} sur {{limit}}.",
      "contract_signatures": "Signatures de contrat : {{current}} sur {{limit}}."
    },
    "feature": {
      "export_planning": "L'export PDF du planning fait partie de l'offre Pro.",
      "customize_contract_templates": "Les modèles de contrats personnalisés font partie de l'offre Pro. Le modèle par défaut reste disponible.",
      "import_volunteers": "L'import CSV de bénévoles fait partie de l'offre Pro. Vous pouvez toujours les ajouter un par un.",
      "auto_remind_signatures": "Les relances de signature automatiques font partie de l'offre Pro.",
      "restrict_event_access": "Limiter un membre à certains événements fait partie de l'offre Pro."
    },
    "suggested_tier": "L'{{tier}} couvre jusqu'à {{volunteers}} bénévoles pour {{price}} €, en paiement unique.",
    "contact_us": "Au-delà de nos formules, écrivez-nous : nous construisons l'offre avec vous.",
    "hint": "Rien n'est perdu, tout votre travail est enregistré. Choisissez une offre et reprenez où vous en étiez.",
    "see_plans": "Voir les offres",
    "later": "Plus tard",
    "unlock_now": "Débloquer pour {{price}} €"
  },
  "pricing": {
    "seo_title": "Tarifs — Coval Flow",
    "seo_description": "Payez à l'événement ou par abonnement. Lancez votre premier événement gratuitement, jusqu'à 10 bénévoles. Tous les prix sont TTC.",
    "eyebrow": "Tarifs",
    "title": "Payez à l'événement, ou à l'année",
    "subtitle": "Un seul temps fort dans l'année ? Payez uniquement cet événement. Plusieurs rendez-vous par saison ? L'abonnement revient moins cher à partir de {{events}} événements par an.",
    "mode": {
      "aria": "Mode de tarification",
      "event": "À l'événement",
      "subscription": "Abonnement"
    },
    "billing": {
      "monthly": "Mensuel",
      "yearly": "Annuel",
      "save_badge": "−{{percent}} %",
      "aria": "Période de facturation"
    },
    "vat_note": "Tous les prix affichés sont TTC.",
    "per_month": "/ mois",
    "billed_monthly": "facturé mensuellement",
    "billed_yearly": "facturé annuellement",
    "free_price": "0 €",
    "free_forever": "Gratuit pour toujours",
    "most_popular": "Le plus populaire",
    "most_common": "Le plus courant",
    "event_tiers": {
      "up_to": "Jusqu'à {{volunteers}} bénévoles",
      "one_off": "paiement unique",
      "cta": "Choisir",
      "tiers": {
        "discovery": {
          "name": "Découverte",
          "tagline": "Pour prendre en main Coval Flow sur un petit événement.",
          "cta": "Commencer"
        },
        "s": {
          "name": "Événement S",
          "tagline": "Association locale, événement d'une journée."
        },
        "m": {
          "name": "Événement M",
          "tagline": "Le format le plus courant : festival ou course de taille moyenne."
        },
        "l": {
          "name": "Événement L",
          "tagline": "Grand festival, plusieurs jours et plusieurs pôles."
        },
        "xl": {
          "name": "Événement XL",
          "tagline": "Très gros dispositif bénévole, jusqu'à un millier de personnes."
        }
      },
      "included_title": "Inclus dans chaque formule événement",
      "included": [
        "Bénévoles, rôles et disponibilités",
        "Timeline de couverture et shifts",
        "Planning automatique et ajustements manuels",
        "Génération et signature électronique des contrats",
        "Modèles de contrats personnalisés",
        "Import CSV de bénévoles",
        "Relances de signature automatiques",
        "Espace bénévole en français et en anglais",
        "Exports PDF et CSV"
      ],
      "access_note": "Accès complet pendant {{months}} mois autour de la date de l'événement, puis archive en lecture seule — vos exports PDF et CSV restent disponibles.",
      "overage_note": "Plus de bénévoles que prévu ? Votre événement continue de fonctionner : nous vous proposons simplement le palier supérieur, au prorata. Jamais de blocage la veille de l'ouverture.",
      "bridge_note": "À partir de {{events}} événements par an, l'abonnement revient moins cher.",
      "over_limit": "Plus de {{volunteers}} bénévoles ? Écrivez-nous, nous construisons l'offre avec vous.",
      "picker": {
        "title": "Pour quel événement ?",
        "copy": "Le forfait {{tier}} couvre un événement. Choisissez lequel.",
        "cancel": "Annuler",
        "empty": "Vous n'avez pas encore d'événement à couvrir.",
        "create_event": "Créer un événement",
        "error": "Impossible de charger vos événements pour le moment.",
        "volunteers_one": "{{count}} bénévole",
        "volunteers_other": "{{count}} bénévoles"
      }
    },
    "credit_packs": {
      "eyebrow": "Packs de crédits",
      "title": "{{events}} événements, {{percent}} % de moins",
      "subtitle": "Vous organisez plusieurs événements mais ne voulez pas d'abonnement ? Achetez vos crédits d'avance : un crédit = un événement de la taille choisie, à utiliser quand vous voulez pendant {{months}} mois.",
      "pack_label": "{{events}} × {{tier}}",
      "instead_of": "au lieu de {{price}} €",
      "per_event": "soit {{price}} € par événement",
      "cta": "Acheter ce pack"
    },
    "plans": {
      "free": {
        "name": "Gratuit",
        "tagline": "Pour votre premier événement ou une petite association.",
        "cta": "Commencer gratuitement",
        "features": [
          "1 événement actif",
          "Jusqu'à 10 bénévoles",
          "2 membres d'équipe",
          "5 signatures de contrat",
          "Timeline rôles & couverture",
          "Planning automatique",
          "Espace bénévole",
          "Français & anglais",
          "Support communautaire"
        ]
      },
      "pro": {
        "name": "Pro",
        "tagline": "Pour les organisateurs qui enchaînent les événements dans l'année.",
        "cta": "Démarrer avec Pro",
        "features_intro": "Tout le plan Gratuit, plus :",
        "features": [
          "Événements illimités",
          "Jusqu'à 150 bénévoles par événement",
          "5 membres d'équipe",
          "Contrats & signature électronique illimités",
          "Modèles de contrats personnalisés",
          "Import CSV de bénévoles",
          "Relances de signature automatiques",
          "Contrôle d'accès par événement",
          "Export PDF du planning",
          "Support par e-mail"
        ]
      },
      "business": {
        "name": "Business",
        "tagline": "Pour les très gros dispositifs bénévoles et les équipes nombreuses.",
        "cta": "Démarrer avec Business",
        "features_intro": "Tout le plan Pro, plus :",
        "features": [
          "Bénévoles illimités par événement",
          "Membres d'équipe illimités",
          "Accompagnement à la mise en route",
          "Support prioritaire"
        ]
      }
    },
    "compare": {
      "eyebrow": "Comparatif",
      "title": "Comparez les plans en détail",
      "feature_col": "Fonctionnalités",
      "unlimited": "Illimité",
      "quota_labels": {
        "activeEvents": "Événements actifs",
        "volunteersPerEvent": "Bénévoles par événement",
        "teamMembers": "Membres d'équipe",
        "contractSignatures": "Signatures de contrat"
      },
      "rows": [
        {
          "label": "Timeline rôles & couverture",
          "free": true,
          "pro": true,
          "business": true
        },
        {
          "label": "Planning automatique",
          "free": true,
          "pro": true,
          "business": true
        },
        {
          "label": "Espace bénévole",
          "free": true,
          "pro": true,
          "business": true
        },
        {
          "label": "Modèles de contrats personnalisés",
          "free": false,
          "pro": true,
          "business": true
        },
        {
          "label": "Import CSV de bénévoles",
          "free": false,
          "pro": true,
          "business": true
        },
        {
          "label": "Relances de signature automatiques",
          "free": false,
          "pro": true,
          "business": true
        },
        {
          "label": "Contrôle d'accès par événement",
          "free": false,
          "pro": true,
          "business": true
        },
        {
          "label": "Export PDF du planning",
          "free": false,
          "pro": true,
          "business": true
        },
        {
          "label": "Accompagnement à la mise en route",
          "free": false,
          "pro": false,
          "business": true
        },
        {
          "label": "Support",
          "free": "Communautaire",
          "pro": "E-mail",
          "business": "Prioritaire"
        }
      ]
    },
    "faq": {
      "eyebrow": "FAQ",
      "title": "Questions sur les tarifs",
      "items": [
        {
          "q": "Quelle différence entre payer à l'événement et l'abonnement ?",
          "a": "Le produit est exactement le même dans les deux cas. La formule à l'événement se paie une seule fois, pour un événement précis, et son prix dépend du nombre de bénévoles. L'abonnement donne accès à des événements illimités toute l'année. À partir de trois événements par an, l'abonnement revient moins cher."
        },
        {
          "q": "Puis-je vraiment commencer gratuitement ?",
          "a": "Oui. Le plan Gratuit n'a ni limite de durée ni carte bancaire. Il couvre un événement actif, jusqu'à 10 bénévoles, 2 membres d'équipe et 5 signatures de contrat."
        },
        {
          "q": "Que se passe-t-il si je dépasse le nombre de bénévoles prévu ?",
          "a": "Rien ne se bloque. Votre événement continue de fonctionner normalement, le dépassement s'affiche dans votre espace et nous vous proposons le palier supérieur au prorata. Nous ne coupons jamais l'accès à un événement en cours."
        },
        {
          "q": "Combien de temps ai-je accès à un événement payé à l'unité ?",
          "a": "Vous gardez l'accès complet pendant 6 mois autour de la date de l'événement — largement de quoi préparer, vivre l'événement et le clôturer. Ensuite l'événement passe en archive consultable, et vos exports PDF et CSV restent disponibles."
        },
        {
          "q": "Comment fonctionnent les packs de crédits ?",
          "a": "Un pack contient 3 crédits à −20 % par rapport à l'achat séparé. Un crédit = un événement de la taille choisie, à utiliser quand vous le souhaitez pendant 24 mois."
        },
        {
          "q": "Les prix sont-ils HT ou TTC ?",
          "a": "Tous les prix affichés sont TTC. Une facture est émise automatiquement après chaque paiement, que ce soit un événement, un pack ou un abonnement."
        },
        {
          "q": "Que m'apporte la facturation annuelle ?",
          "a": "La facturation annuelle fait passer le plan Pro de 29 € à 24 € par mois, et le plan Business de 79 € à 65 € par mois."
        },
        {
          "q": "Puis-je annuler à tout moment ?",
          "a": "Oui. Aucun engagement : annulez quand vous le souhaitez. Vos événements passés restent consultables et exportables, et vous retombez sur le plan Gratuit."
        }
      ]
    }
  },
  "publicGuestList": {
    "invalid": "Ce lien de liste d'invités est invalide ou a été révoqué.",
    "subtitle": "Guest List",
    "summary": "{{guests}} invité(s) · {{people}} personne(s) attendue(s)",
    "empty": "Aucun invité pour le moment.",
    "guest_count": "{{n}} personnes",
    "present": "Présent"
  },
  "guestList": {
    "search_placeholder": "Rechercher un invité",
    "no_match": "Aucun invité ne correspond à votre recherche.",
    "guest_count": "{{n}} personnes",
    "present": "Présent",
    "mark_present": "Pointer"
  },
  "billing": {
    "checkout_failed": "Le paiement n'a pas pu démarrer. Réessayez dans un instant.",
    "back_to_app": "Retour à mes événements",
    "see_plans": "Voir les offres",
    "success": {
      "badge": "Paiement reçu",
      "title": "Tout est bon",
      "copy": "Votre accès s'ouvre dès la confirmation du paiement, dans quelques secondes."
    },
    "cancelled": {
      "badge": "Paiement annulé",
      "title": "Rien n'a été débité",
      "copy": "Votre travail est intact. Reprenez où vous en étiez."
    },
    "manage_subscription": "Gérer mon abonnement",
    "manage_hint": "Carte, factures et résiliation.",
    "upgrade_cta": "Passer à une offre supérieure"
  },
  "errors": {
    "codes": {
      "subscription_already_running": "Cette organisation a déjà un abonnement en cours. Modifiez-le ou résiliez-le depuis l'espace de facturation.",
      "event_already_covered": "Cet événement est déjà couvert par un pack de taille égale ou supérieure.",
      "event_not_coverable": "Cet événement est clôturé : un pack n'y débloquerait rien."
    }
  },
  "finances": {
    "eyebrow": "Finances",
    "title": "Paiements aux bénévoles",
    "subtitle": "Défraiements et trajets des contrats signés.",
    "filters_eyebrow": "Période",
    "filters_title": "Affichage",
    "year_label": "Année",
    "view_label": "Vue",
    "view": {
      "chart": "Graphique",
      "table": "Tableau"
    },
    "stats": {
      "paid": "Déjà payé",
      "to_pay": "Reste à payer",
      "allowance": "Défraiements",
      "travel": "Trajets"
    },
    "series": {
      "allowance": "Défraiement",
      "travel": "Trajet",
      "allowance_paid": "Défraiement payé",
      "allowance_to_pay": "Défraiement à payer",
      "travel_paid": "Trajet payé",
      "travel_to_pay": "Trajet à payer"
    },
    "legend": {
      "to_pay": "Hachuré : à payer",
      "cap": "Plafond annuel"
    },
    "monthly": {
      "title": "Tous les bénévoles",
      "subtitle": "Par mois de l'événement, en {{year}}.",
      "chart_label": "Paiements par mois",
      "column_label": "{{month}} : {{amount}}",
      "table_caption": "Paiements aux bénévoles par mois"
    },
    "volunteers": {
      "title": "Par bénévole",
      "subtitle": "Total de l'année par bénévole.",
      "subtitle_cap": "Total de l'année, face au plafond de {{cap}}.",
      "add_label": "Ajouter un bénévole",
      "add_placeholder": "Rechercher…",
      "select_all": "Tout afficher",
      "clear": "Effacer",
      "remove": "Retirer {{name}}",
      "more": "+{{count}}",
      "empty_selection": "Choisissez un ou plusieurs bénévoles.",
      "chart_label": "Paiements par bénévole",
      "row_label": "{{name}} : {{amount}}",
      "over_cap": "Plafond dépassé",
      "deleted": "Compte supprimé",
      "table_caption": "Paiements par bénévole",
      "subtitle_range": "Du {{from}} au {{to}}.",
      "subtitle_range_cap": "Du {{from}} au {{to}}, face au plafond de {{cap}}.",
      "subtitle_range_multi_year": "Du {{from}} au {{to}}. Plafond annuel non comparé sur plusieurs années.",
      "empty_range": "Aucun paiement sur cette période.",
      "range_error": "Impossible de charger cette période."
    },
    "range": {
      "from": "Du",
      "to": "Au",
      "reset": "Toute l'année"
    },
    "table": {
      "month": "Mois",
      "volunteer": "Bénévole",
      "total": "Total"
    },
    "empty_title": "Aucun paiement en {{year}}",
    "empty_hint": "Les montants apparaissent dès qu'un contrat est signé.",
    "load_error": "Impossible de charger les paiements.",
    "note": "Un montant passe en « payé » quand sa ligne est marquée Payé dans la compta de l'événement."
  }
}
